import { useTheme } from "../ThemeContext";
import { useState, useEffect, useRef } from "react";
import { fmt, valorReal } from "../theme";
import { post, get } from "../api";

/* ═══ HELPERS ═══ */
function fmtGs(brl,tx){return "₲ "+Math.round((parseFloat(brl)||0)*(parseFloat(tx)||1)).toLocaleString("pt-BR");}
function pv(v){var s=String(v).trim();if(!s)return 0;if(s.indexOf(",")>=0)return parseFloat(s.replace(/\./g,"").replace(",","."))||0;return parseFloat(s)||0;}
const UID=()=>Date.now()+"_"+Math.random().toString(36).slice(2,6);
const fmtDt=(d)=>{if(!d)return"";try{const dt=new Date(d);return dt.toLocaleDateString("pt-BR")+" "+dt.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});}catch{return d;}};
const fmtHora=(d)=>{if(!d)return"";try{return new Date(d).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});}catch{return"";}};

const CORES_MESA={livre:{bg:"#0d2818",border:"#22C55E40",text:"#22C55E"},ocupada:{bg:"#2a0a09",border:"#EF444460",text:"#EF4444"}};
const FORMAS=[{k:"dinheiro",l:"Dinheiro",ico:"💵",n:"1"},{k:"pix",l:"PIX",ico:"📱",n:"2"},{k:"credito",l:"Crédito",ico:"💳",n:"3"},{k:"debito",l:"Débito",ico:"💳",n:"4"},{k:"cashback",l:"Cashback",ico:"🪙",n:"5"}];
const mono="'JetBrains Mono','Fira Code',monospace";

const DC={
  bg:"#0f1117",bgSoft:"#161923",card:"#1c1f2e",cardHover:"#242838",
  border:"#2a2e3f",borderLight:"#353a50",
  accent:"#E8201A",accentSoft:"#E8201A20",accentGlow:"#E8201A40",
  green:"#22C55E",greenSoft:"#22C55E18",greenGlow:"#22C55E40",
  blue:"#3B82F6",blueSoft:"#3B82F618",
  orange:"#F97316",orangeSoft:"#F9731618",
  purple:"#8B5CF6",purpleSoft:"#8B5CF618",
  yellow:"#EAB308",cyan:"#06B6D4",
  text:"#E8E9ED",textSoft:"#9CA3B4",textMuted:"#5C6378",white:"#FFFFFF",
};

const sInput={padding:"8px 12px",borderRadius:6,border:`1px solid ${DC.border}`,background:DC.bgSoft,color:DC.text,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"};
const sBtn=(bg=DC.accent,cor=DC.white)=>({padding:"10px 18px",borderRadius:8,border:"none",fontWeight:700,fontSize:13,cursor:"pointer",transition:"all .12s",background:bg,color:cor});

/* ══════════════════════════════════════════
   COMPONENTE PRINCIPAL
══════════════════════════════════════════ */
export default function PDV({orders,onAdvance,onRefresh,lojaId:_lid,goTo}){
  const lojaId=_lid||(()=>{try{for(const k of["mixup_loja","loja","user"]){const r=localStorage.getItem(k);if(!r)continue;const u=JSON.parse(r);const id=u?.loja_id||u?.id;if(id)return id;}}catch{}return null;})();
  const LK=(k)=>k+"_"+(lojaId||1);
  const{theme:C}=useTheme();
  const notify=(msg,ok=true)=>{setToast({msg,ok});setTimeout(()=>setToast(null),2800);};

  // ═══ SESSÃO CAIXA ═══
  const[logado,setLogado]=useState(()=>{try{const s=JSON.parse(localStorage.getItem(LK("pdv_sessao")));if(s&&s.id!==undefined)return s;return null;}catch{return null;}});
  const[loginSenha,setLoginSenha]=useState("");
  const[loginErro,setLoginErro]=useState("");
  const[loginLoading,setLoginLoading]=useState(false);
  const[usuarios,setUsuarios]=useState([]);
  const[usuariosCarregados,setUsuariosCarregados]=useState(false);
  const[loginUsuarioId,setLoginUsuarioId]=useState("");
  const[fundoCaixa,setFundoCaixa]=useState("");
  const[etapaLogin,setEtapaLogin]=useState("selecionar"); // selecionar | senha | fundo
  const[showFechamento,setShowFechamento]=useState(false);
  const[fechDinheiro,setFechDinheiro]=useState("");
  const[fechSenha,setFechSenha]=useState("");
  const[fechSenhaErro,setFechSenhaErro]=useState("");
  const[fechLoading,setFechLoading]=useState(false);

  // ═══ ESTADOS GERAIS ═══
  const[abaAtiva,setAbaAtiva]=useState("vendas");
  const[loja,setLoja]=useState(null);
  const[toast,setToast]=useState(null);
  const[mesas,setMesas]=useState(()=>{try{return JSON.parse(localStorage.getItem(LK("pdv_mesas")))||{};}catch{return{};}});
  const[carros,setCarros]=useState(()=>{try{return JSON.parse(localStorage.getItem(LK("pdv_carros")))||{};}catch{return{};}});
  const[comandas,setComandas]=useState(()=>{try{return JSON.parse(localStorage.getItem(LK("pdv_comandas")))||{};}catch{return{};}});
  const[totalMesas,setTotalMesas]=useState(()=>parseInt(localStorage.getItem(LK("pdv_total_mesas")))||15);
  const[totalCarros,setTotalCarros]=useState(()=>parseInt(localStorage.getItem(LK("pdv_total_carros")))||10);
  const[totalComandas,setTotalComandas]=useState(()=>parseInt(localStorage.getItem(LK("pdv_total_comandas")))||20);
  // Labels persistentes das mesas/carros/comandas (Varanda A, VIP...)
  const[labels,setLabels]=useState(()=>{try{return JSON.parse(localStorage.getItem(LK("pdv_labels")))||{mesa:{},carro:{},comanda:{}};}catch{return{mesa:{},carro:{},comanda:{}};}});
  const[modalLabelsTipo,setModalLabelsTipo]=useState(null); // null | "mesa" | "carro" | "comanda"
  // ═══ MOVIMENTAÇÕES DE CAIXA (sangria + suprimento) ═══
  const[movsSessao,setMovsSessao]=useState([]); // lista da sessão atual
  const[showMovModal,setShowMovModal]=useState(null); // null | "sangria" | "suprimento"
  const[movValor,setMovValor]=useState("");
  const[movMotivo,setMovMotivo]=useState("");
  const[movLoading,setMovLoading]=useState(false);
  const[showHistMov,setShowHistMov]=useState(false); // ver histórico do turno
  // Funcionalidades habilitadas (carregadas do servidor via config_loja)
  const[usaMesa,setUsaMesa]=useState(()=>{const v=localStorage.getItem(LK("pdv_usa_mesa"));return v===null?true:v==="1";});
  const[usaCarro,setUsaCarro]=useState(()=>{const v=localStorage.getItem(LK("pdv_usa_carro"));return v===null?true:v==="1";});
  const[usaComanda,setUsaComanda]=useState(()=>{const v=localStorage.getItem(LK("pdv_usa_comanda"));return v===null?false:v==="1";});
  const[ativoNum,setAtivoNum]=useState(null);
  const[ativoTipo,setAtivoTipo]=useState(null);
  const[selNum,setSelNum]=useState(1);
  const[garcomAtivo,setGarcomAtivo]=useState(null);
  const[showGarcomModal,setShowGarcomModal]=useState(false);
  const[garcomPendente,setGarcomPendente]=useState(null);
  const[produtos,setProdutos]=useState([]);
  const[categorias,setCategorias]=useState([]);
  const[catAtiva,setCatAtiva]=useState("todos");
  const[busca,setBusca]=useState("");
  const[prodSel,setProdSel]=useState(0);
  const[comanda,setComanda]=useState([]);
  const[obs,setObs]=useState("");
  const[itemSel,setItemSel]=useState(null);
  const[loading,setLoading]=useState(false);
  const[modoPag,setModoPag]=useState("rapido");
  const[pagForma,setPagForma]=useState(null);
  const[pagRecebido,setPagRecebido]=useState("");
  const[pag,setPag]=useState({dinheiro:"",pix:"",credito:"",debito:"",cashback:""});
  const[desconto,setDesconto]=useState("");
  const[descontoTipo,setDescontoTipo]=useState("real");
  const[cambio,setCambio]=useState(()=>{try{const t=JSON.parse(localStorage.getItem(LK("pdv_taxas")));return{pyg:"",usd:"",taxaPyg:t?.pyg||"1240",taxaUsd:t?.usd||"5.40"};}catch{return{pyg:"",usd:"",taxaPyg:"1240",taxaUsd:"5.40"};}});
  const[comandaAberta,setComandaAberta]=useState(false);
  const[showConfig,setShowConfig]=useState(false);
  const[showPagamento,setShowPagamento]=useState(false);
  const[configAba,setConfigAba]=useState("geral");
  const[cxFiltro,setCxFiltro]=useState({de:"",ate:"",caixa:"",garcom:"",forma:"",canal:""});
  const[cxRelatorio,setCxRelatorio]=useState([]);
  const[cxLoading,setCxLoading]=useState(false);
  const[formUsuario,setFormUsuario]=useState({id:null,nome:"",senha:"",tipo:"garcom"});
  const[usuarioLoading,setUsuarioLoading]=useState(false);
  const buscaRef=useRef(null);const pagRef=useRef(null);const printRef=useRef(null);const garcomSomRef=useRef(null);

  // ═══ HELPERS MESA/CARRO/COMANDA ═══
  const getStore=(t)=>t==="carro"?carros:t==="comanda"?comandas:mesas;
  const setStore=(t,d)=>{
    if(t==="carro"){setCarros(d);localStorage.setItem(LK("pdv_carros"),JSON.stringify(d));}
    else if(t==="comanda"){setComandas(d);localStorage.setItem(LK("pdv_comandas"),JSON.stringify(d));}
    else{setMesas(d);localStorage.setItem(LK("pdv_mesas"),JSON.stringify(d));}
  };
  const getItem=(t,n)=>(getStore(t)[n])||{status:"livre",itens:[],abertura:null,obs:""};
  const itemSt=(t,n)=>{const m=getItem(t,n);return(!m.itens||m.itens.length===0)?"livre":"ocupada";};
  const itemTot=(t,n)=>(getItem(t,n).itens||[]).filter(i=>!i.cancelado).reduce((s,i)=>s+(i.preco_total||0),0);
  const itemTmp=(t,n)=>{const m=getItem(t,n);if(!m.abertura)return"";const min=Math.floor((Date.now()-new Date(m.abertura).getTime())/60000);return min<60?min+"min":Math.floor(min/60)+"h"+(min%60>0?(min%60)+"m":"");};
  const itemQtd=(t,n)=>(getItem(t,n).itens||[]).filter(i=>!i.cancelado).length;
  // Nome do cliente (operacional, no JSON da mesa) — some quando mesa fecha
  const getCliente=(t,n)=>(getItem(t,n).cliente_nome||"");
  const setCliente=(t,n,nome)=>{
    const st={...getStore(t)};
    const ex=st[n]||{status:"livre",itens:[],abertura:null,obs:"",garcom:null};
    st[n]={...ex,cliente_nome:(nome||"").trim()};
    setStore(t,st);
    // Sincroniza com servidor (mesma chamada que sync_mesas)
    fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"sync_mesas",loja_id:lojaId||1,tipo:t,dados:Object.assign({},st,{_config:{total:t==="mesa"?totalMesas:t==="carro"?totalCarros:totalComandas}})})}).catch(()=>{});
  };
  // Nome de exibição (label persistente OU "Mesa N")
  const nomeMesa=(t,n)=>{
    const lblObj=(labels&&labels[t])||{};
    return lblObj[String(n)]||lblObj[n]||(t==="carro"?`Carro ${n}`:t==="comanda"?`Comanda ${n}`:`Mesa ${n}`);
  };
  // Salvar labels no servidor + cache local
  const salvarLabels=async(tipo,novos)=>{
    try{
      const r=await fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"salvar_labels",loja_id:lojaId||1,tipo,labels:novos})});
      const d=await r.json();
      if(d.ok){
        // Limpa vazios pra não persistir entrada vazia
        const limpos={};
        Object.keys(novos||{}).forEach(k=>{const v=String(novos[k]||"").trim();if(v)limpos[k]=v;});
        const lb={...labels,[tipo]:limpos};
        setLabels(lb);
        localStorage.setItem(LK("pdv_labels"),JSON.stringify(lb));
        notify(`Nomes salvos (${d.salvos||0} ativos, ${d.removidos||0} removidos)`,true);
        setModalLabelsTipo(null);
      }else{
        notify("Erro ao salvar: "+(d.erro||"desconhecido"),false);
      }
    }catch(e){notify("Erro de conexão",false);}
  };

  // ═══ MOVIMENTAÇÕES DE CAIXA ═══
  const sessaoIdAtual=logado?(`${lojaId||1}_${logado.id||0}_${logado.inicio||""}`):"";
  const carregarMovs=async()=>{
    if(!logado||!sessaoIdAtual)return;
    try{
      const r=await fetch(`https://mixupbr.com.br/api/pdv_comandas/?acao=caixa_mov_listar&loja_id=${lojaId||1}&sessao_id=${encodeURIComponent(sessaoIdAtual)}`);
      const d=await r.json();
      if(d.ok)setMovsSessao(d.movimentacoes||[]);
    }catch(e){}
  };
  const registrarMov=async()=>{
    const v=pv(movValor)||0;
    if(v<=0){notify("Valor inválido",false);return;}
    if(!movMotivo.trim()){notify("Motivo obrigatório",false);return;}
    setMovLoading(true);
    try{
      const r=await fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({
        acao:"caixa_mov_criar",
        loja_id:lojaId||1,
        sessao_id:sessaoIdAtual,
        tipo:showMovModal,
        valor:v,
        motivo:movMotivo.trim(),
        operador_id:logado?.id||0,
        operador_nome:logado?.nome||""
      })});
      const d=await r.json();
      if(d.ok){
        notify(`${showMovModal==="sangria"?"📉 Sangria":"📈 Suprimento"} de ${fmt(v)} registrado`,true);
        setMovValor("");setMovMotivo("");setShowMovModal(null);
        carregarMovs();
      }else{
        notify("Erro: "+(d.erro||"desconhecido"),false);
      }
    }catch(e){notify("Erro de conexão",false);}
    setMovLoading(false);
  };

  // ═══ CARREGAR ═══
  const getLocalUsers=()=>{try{return JSON.parse(localStorage.getItem(LK("pdv_usuarios_local"))||"[]");}catch{return[];}};
  const saveLocalUsers=(list)=>{localStorage.setItem(LK("pdv_usuarios_local"),JSON.stringify(list));};

  const carregarUsuarios=async()=>{
    // Tentar API primeiro
    try{
      const r=await get("pdv_usuarios",{loja_id:lojaId||1,acao:"listar"});
      const u=r.dados||r.usuarios||(Array.isArray(r)?r:[]);
      if(u.length>0){
        setUsuarios(u);
        saveLocalUsers(u); // Cachear localmente
        setUsuariosCarregados(true);
        return;
      }
    }catch(e){
      console.log("PDV: API pdv_usuarios indisponível:",e.message);
    }
    // Fallback: localStorage
    const local=getLocalUsers();
    setUsuarios(local);
    setUsuariosCarregados(true);
  };

  useEffect(()=>{
    get("categorias_loja",{loja_id:lojaId||1}).then(function(rc){return rc;}).catch(function(){return{dados:[]};}).then(function(rc){
      var cats=rc.dados||rc.categorias||(Array.isArray(rc)?rc:[]);
      var catMap={};cats.forEach(function(c){catMap[String(c.id)]=c.nome;});
      get("produtos",{loja_id:lojaId||1}).then(function(r){
        var p=(r.dados||r.produtos||(Array.isArray(r)?r:[])).map(function(x){return Object.assign({},x,{categoria:catMap[String(x.categoria_id)]||x.categoria_nome||"Outros"});});
        setProdutos(p);setCategorias([...new Set(p.map(function(x){return x.categoria;}).filter(Boolean))]);
      }).catch(function(){});
    });
    get("loja_config",{loja_id:lojaId||1,acao:"dados"}).then(r=>{if(r.dados?.id)setLoja(r.dados);}).catch(()=>{});
    // Carrega configuração de funcionalidades da loja (usa_mesa/carro/comanda)
    fetch("https://mixupbr.com.br/api/pdv_comandas/?acao=config_loja&loja_id="+(lojaId||1))
      .then(r=>r.json())
      .then(d=>{
        if(d.ok&&d.loja){
          setUsaMesa(!!d.loja.usa_mesa);
          setUsaCarro(!!d.loja.usa_carro);
          setUsaComanda(!!d.loja.usa_comanda);
          localStorage.setItem(LK("pdv_usa_mesa"),d.loja.usa_mesa?"1":"0");
          localStorage.setItem(LK("pdv_usa_carro"),d.loja.usa_carro?"1":"0");
          localStorage.setItem(LK("pdv_usa_comanda"),d.loja.usa_comanda?"1":"0");
        }
      }).catch(()=>{});
    // Carrega labels persistentes das mesas/carros/comandas (Varanda A, VIP...)
    fetch("https://mixupbr.com.br/api/pdv_comandas/?acao=get_labels&loja_id="+(lojaId||1))
      .then(r=>r.json())
      .then(d=>{
        if(d.ok&&d.labels){
          const lb = {mesa: d.labels.mesa||{}, carro: d.labels.carro||{}, comanda: d.labels.comanda||{}};
          setLabels(lb);
          localStorage.setItem(LK("pdv_labels"), JSON.stringify(lb));
        }
      }).catch(()=>{});
    carregarUsuarios();
    try{const t=JSON.parse(localStorage.getItem(LK("pdv_taxas")));if(t)setCambio(c=>({...c,taxaPyg:t.pyg||c.taxaPyg,taxaUsd:t.usd||c.taxaUsd}));}catch{}
  },[lojaId]);

  // ═══ POLLING COMANDAS DO GARÇOM (tempo real) ═══
  useEffect(()=>{
    if(!logado||logado._temp)return;
    const lid=lojaId||1;
    const poll=async()=>{
      try{
        const r=await fetch(`https://mixupbr.com.br/api/pdv_comandas/?acao=pendentes&loja_id=${lid}`);
        const d=await r.json();
        if(!d.ok||!d.dados||d.dados.length===0)return;
        d.dados.forEach(function(cmd){
          var tipo=cmd.mesa_tipo||"mesa";
          var num=parseInt(cmd.mesa_num)||0;
          if(!num)return;
          var novosItens=(cmd.itens||[]).map(function(it){return{uid:UID(),produto_id:it.produto_id,codigo:it.produto_id,nome:it.nome,quantidade:parseInt(it.quantidade)||1,preco_unitario:parseFloat(it.preco_unitario)||0,preco_total:parseFloat(it.preco_total)||0,adicionais:"",cancelado:false};});
          var garcom=cmd.garcom_id?{id:cmd.garcom_id,nome:cmd.garcom_nome||""}:null;
          var modoCmd=cmd.modo||"adicionar";
          if(tipo==="carro"){
            setCarros(function(prev){var st={...prev};var ex=st[num]||{status:"livre",itens:[],abertura:null,obs:"",garcom:null};var itensFinais=modoCmd==="substituir"?novosItens:[...(ex.itens||[]),...novosItens];st[num]={...ex,itens:itensFinais,status:itensFinais.length>0?"ocupada":"livre",abertura:ex.abertura||new Date().toISOString(),garcom:garcom||ex.garcom};localStorage.setItem(LK("pdv_carros"),JSON.stringify(st));return st;});
          }else if(tipo==="comanda"||tipo==="balcao"){
            setComandas(function(prev){var st={...prev};var ex=st[num]||{status:"livre",itens:[],abertura:null,obs:"",garcom:null};var itensFinais=modoCmd==="substituir"?novosItens:[...(ex.itens||[]),...novosItens];st[num]={...ex,itens:itensFinais,status:itensFinais.length>0?"ocupada":"livre",abertura:ex.abertura||new Date().toISOString(),garcom:garcom||ex.garcom};localStorage.setItem(LK("pdv_comandas"),JSON.stringify(st));return st;});
          }else{
            setMesas(function(prev){var st={...prev};var ex=st[num]||{status:"livre",itens:[],abertura:null,obs:"",garcom:null};var itensFinais=modoCmd==="substituir"?novosItens:[...(ex.itens||[]),...novosItens];st[num]={...ex,itens:itensFinais,status:itensFinais.length>0?"ocupada":"livre",abertura:ex.abertura||new Date().toISOString(),garcom:garcom||ex.garcom};localStorage.setItem(LK("pdv_mesas"),JSON.stringify(st));return st;});
          }
          // Confirmar recebimento na API
          fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"confirmar",id:cmd.id,loja_id:lid})}).catch(function(){});
          notify("📋 "+(tipo==="carro"?"Carro":tipo==="comanda"||tipo==="balcao"?"Comanda":"Mesa")+" "+num+" — "+(cmd.garcom_nome||"Garçom")+" enviou "+novosItens.length+" item(ns)");
        });
        // Som de notificação
        try{if(!garcomSomRef.current)garcomSomRef.current=new Audio("/mixup-lojista/notification.mp3");garcomSomRef.current.currentTime=0;garcomSomRef.current.play().catch(function(){});}catch(e){}
      }catch(e){console.log("Poll garçom:",e.message);}
    };
    var tmr=setInterval(poll,5000);
    poll();
    return function(){clearInterval(tmr);};
  },[logado,lojaId]);

  // ═══ SYNC MESAS → SERVIDOR (pra garçom ver mudanças) ═══
  useEffect(()=>{
    if(!logado||logado._temp)return;
    var lid=lojaId||1;
    var tmr=setTimeout(function(){
      fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"sync_mesas",loja_id:lid,tipo:"mesa",dados:Object.assign({},mesas,{_config:{total:totalMesas}})})}).catch(function(){});
    },500);
    return function(){clearTimeout(tmr);};
  },[mesas,logado,totalMesas]);
  useEffect(()=>{
    if(!logado||logado._temp)return;
    var lid=lojaId||1;
    var tmr=setTimeout(function(){
      fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"sync_mesas",loja_id:lid,tipo:"carro",dados:Object.assign({},carros,{_config:{total:totalCarros}})})}).catch(function(){});
    },500);
    return function(){clearTimeout(tmr);};
  },[carros,logado,totalCarros]);
  useEffect(()=>{
    if(!logado||logado._temp)return;
    var lid=lojaId||1;
    var tmr=setTimeout(function(){
      fetch("https://mixupbr.com.br/api/pdv_comandas/",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({acao:"sync_mesas",loja_id:lid,tipo:"comanda",dados:Object.assign({},comandas,{_config:{total:totalComandas}})})}).catch(function(){});
    },500);
    return function(){clearTimeout(tmr);};
  },[comandas,logado,totalComandas]);

  // ═══ Carregar movs do caixa ao logar e a cada 30s ═══
  useEffect(()=>{
    if(!logado||logado._temp)return;
    carregarMovs();
    const tmr=setInterval(carregarMovs,30000);
    return()=>clearInterval(tmr);
  },[logado?.id,logado?.inicio]);

  // ═══ LOGIN / ABERTURA ═══
  const caixas=usuarios.filter(u=>(u.tipo==="caixa"||u.tipo==="admin")&&u.ativo!=="0"&&u.ativo!==0);
  const garcons=usuarios.filter(u=>u.tipo==="garcom"&&u.ativo!=="0"&&u.ativo!==0);

  const fazerLogin=async()=>{
    if(!loginUsuarioId){setLoginErro("Selecione o operador");return;}
    if(!loginSenha.trim()){setLoginErro("Digite a senha");return;}
    setLoginLoading(true);setLoginErro("");
    // Buscar o user na lista (local ou API)
    const userSel=usuarios.find(u=>String(u.id)===String(loginUsuarioId));
    // Tentar API
    try{
      const r=await post("pdv_usuarios",{acao:"login",id:loginUsuarioId,senha:loginSenha,loja_id:lojaId||1});
      if(r.ok||r.sucesso||r.dados){
        const user=r.dados||r.usuario||userSel||{id:loginUsuarioId,nome:"Operador"};
        setEtapaLogin("fundo");setLoginErro("");
        setLogado({id:user.id,nome:user.nome,tipo:user.tipo||"caixa",_temp:true});
        setLoginLoading(false);return;
      }else{
        // API não encontrou — se existe localmente, aceitar
        if(userSel){
          setEtapaLogin("fundo");setLoginErro("");
          setLogado({id:userSel.id,nome:userSel.nome,tipo:userSel.tipo||"caixa",_temp:true});
          setLoginLoading(false);return;
        }
        setLoginErro(r.erro||r.mensagem||"Senha incorreta");
        setLoginLoading(false);return;
      }
    }catch(e){
      console.log("PDV login API erro:",e.message);
      // Fallback: se API fora, aceitar qualquer senha (modo local)
      if(userSel){
        setEtapaLogin("fundo");setLoginErro("");
        setLogado({id:userSel.id,nome:userSel.nome,tipo:userSel.tipo||"caixa",_temp:true});
        notify("Login local (API indisponível)");
        setLoginLoading(false);return;
      }
      setLoginErro("API indisponível. Use 'Entrar como Admin'.");
    }
    setLoginLoading(false);
  };

  const abrirCaixa=()=>{
    const fundo=pv(fundoCaixa)||0;
    // Usar horário LOCAL (mesmo formato do criado_em do banco: YYYY-MM-DD HH:MM:SS)
    const agora=new Date();
    const inicioLocal=agora.getFullYear()+"-"+String(agora.getMonth()+1).padStart(2,"0")+"-"+String(agora.getDate()).padStart(2,"0")+" "+String(agora.getHours()).padStart(2,"0")+":"+String(agora.getMinutes()).padStart(2,"0")+":"+String(agora.getSeconds()).padStart(2,"0");
    const sessao={
      id:logado?.id||0,
      nome:logado?.nome||"Operador",
      tipo:logado?.tipo||"caixa",
      inicio:inicioLocal,
      fundo_caixa:fundo,
    };
    localStorage.setItem(LK("pdv_sessao"),JSON.stringify(sessao));
    setLogado(sessao);
    setFundoCaixa("");
    setEtapaLogin("selecionar");
    notify("Caixa aberto! Fundo: R$ "+fundo.toFixed(2));
  };

  const entrarSemLogin=()=>{
    setEtapaLogin("fundo");
    setLogado({id:0,nome:"Admin",tipo:"admin",_temp:true});
  };

  // ═══ FECHAMENTO DE CAIXA ═══
  const vendasSessao=(orders||[]).filter(o=>{
    if(!logado?.inicio)return false;
    var oCriado=(o.criado_em||"").replace(" ","T");
    var sessaoInicio=(logado.inicio||"").replace(" ","T");
    if(oCriado<sessaoInicio||o.status!=="entregue")return false;
    // Filtrar pelo operador: só vendas DESTE caixa
    if(logado.id&&o.caixa_id&&String(o.caixa_id)===String(logado.id))return true;
    if(logado.nome&&o.caixa_nome&&o.caixa_nome===logado.nome)return true;
    // Vendas sem caixa_id/caixa_nome (legado ou delivery) não entram na sessão
    if(o.canal==="pdv_interno"&&!o.caixa_id&&!o.caixa_nome)return true;
    return false;
  });
  const fatSessao=vendasSessao.reduce((s,o)=>s+valorReal(o),0);
  const dinheiroSessao=vendasSessao.filter(o=>(o.forma_pagamento||"").includes("dinheiro")).reduce((s,o)=>s+valorReal(o),0);
  const pixSessao=vendasSessao.filter(o=>(o.forma_pagamento||"").includes("pix")).reduce((s,o)=>s+valorReal(o),0);
  const creditoSessao=vendasSessao.filter(o=>(o.forma_pagamento||"").includes("credit")).reduce((s,o)=>s+valorReal(o),0);
  const debitoSessao=vendasSessao.filter(o=>(o.forma_pagamento||"").includes("debit")).reduce((s,o)=>s+valorReal(o),0);
  const cashbackSessao=vendasSessao.filter(o=>(o.forma_pagamento||"").includes("cashback")).reduce((s,o)=>s+valorReal(o),0);
  const fundoVal=logado?.fundo_caixa||0;
  // Soma das movimentações da sessão atual (sangrias e suprimentos)
  const totalSuprimentos=(movsSessao||[]).filter(m=>m.tipo==="suprimento").reduce((s,m)=>s+parseFloat(m.valor||0),0);
  const totalSangrias=(movsSessao||[]).filter(m=>m.tipo==="sangria").reduce((s,m)=>s+parseFloat(m.valor||0),0);
  const dinheiroEsperado=fundoVal+dinheiroSessao+totalSuprimentos-totalSangrias;

  const fecharCaixa=async()=>{
    // Admin sem login (id=0) fecha sem senha
    if(logado?.id&&logado.id!==0){
      if(!fechSenha.trim()){setFechSenhaErro("Digite a senha para fechar o caixa");return;}
      setFechLoading(true);setFechSenhaErro("");
      // Validar senha via API
      try{
        const r=await post("pdv_usuarios",{acao:"login",id:logado.id,senha:fechSenha,loja_id:lojaId||1});
        if(!r.ok&&!r.sucesso&&!r.dados){
          setFechSenhaErro(r.erro||"Senha incorreta");setFechLoading(false);return;
        }
      }catch(e){
        // Se API indisponível, aceitar (modo offline)
      }
      setFechLoading(false);
    }
    const dinhContado=pv(fechDinheiro);
    const diferenca=dinhContado-dinheiroEsperado;
    // Horário local (mesmo formato do inicio)
    const agora=new Date();
    const fimLocal=agora.getFullYear()+"-"+String(agora.getMonth()+1).padStart(2,"0")+"-"+String(agora.getDate()).padStart(2,"0")+" "+String(agora.getHours()).padStart(2,"0")+":"+String(agora.getMinutes()).padStart(2,"0")+":"+String(agora.getSeconds()).padStart(2,"0");
    // Registrar fechamento via API
    try{
      post("pdv_usuarios",{
        acao:"fechar_caixa",loja_id:lojaId||1,
        caixa_id:logado?.id,caixa_nome:logado?.nome,
        inicio:logado?.inicio,fim:fimLocal,
        fundo_caixa:fundoVal,
        total_vendas:fatSessao,total_dinheiro:dinheiroSessao,
        total_pix:pixSessao,total_credito:creditoSessao,total_debito:debitoSessao,
        total_cashback:cashbackSessao,
        dinheiro_contado:dinhContado,diferenca:diferenca,
        qtd_vendas:vendasSessao.length,
      }).catch(()=>{});
    }catch{}
    localStorage.removeItem(LK("pdv_sessao"));
    setLogado(null);setLoginSenha("");setLoginUsuarioId("");setFundoCaixa("");
    setShowFechamento(false);setFechDinheiro("");setFechSenha("");setFechSenhaErro("");setAbaAtiva("vendas");setComanda([]);
    setEtapaLogin("selecionar");
  };

  // ═══ IMPRIMIR RELATÓRIO ═══
  const imprimirRelatorio=()=>{
    const hoje=new Date().toLocaleDateString("pt-BR");
    const hora=new Date().toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});

    // ═══ PDV Desktop — manda como recibo especial ═══
    const isPDVDesktop = typeof window !== "undefined" && (window.__ELECTRON_PDV__ === true || !!window.__PRINT_SERVER__);
    if (isPDVDesktop) {
      const baseUrl = window.__PRINT_SERVER__ || "http://localhost:3456";
      // Monta como "recibo" mas com itens estruturados pra relatório
      const dadosRel = {
        codigo: "RELATORIO",
        data: `${hoje} ${hora}`,
        operador: logado?.nome || "—",
        itens: [
          { nome: `Qtd vendas: ${vendasSessao.length}`, quantidade: 1, subtotal: 0 },
          { nome: "Dinheiro", quantidade: 1, subtotal: dinheiroSessao || 0 },
          { nome: "PIX", quantidade: 1, subtotal: pixSessao || 0 },
          { nome: "Credito", quantidade: 1, subtotal: creditoSessao || 0 },
          { nome: "Debito", quantidade: 1, subtotal: debitoSessao || 0 },
          { nome: "Cashback", quantidade: 1, subtotal: cashbackSessao || 0 },
          { nome: "Fundo de caixa", quantidade: 1, subtotal: fundoVal || 0 },
          { nome: "Esperado dinheiro", quantidade: 1, subtotal: dinheiroEsperado || 0 }
        ],
        subtotal: fatSessao || 0,
        desconto: 0,
        total: fatSessao || 0,
        forma_pagamento: "RELATORIO CAIXA"
      };
      fetch(baseUrl + "/recibo", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dadosRel)
      }).catch(()=>{});
      return;
    }

    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Relatório PDV</title>
<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:'Courier New',monospace;font-size:12px;width:300px;padding:10px;color:#000}
.center{text-align:center}.bold{font-weight:bold}.line{border-bottom:1px dashed #000;margin:6px 0}
.row{display:flex;justify-content:space-between}.big{font-size:16px;font-weight:900}
h2{font-size:14px;margin:4px 0}</style></head><body>
<div class="center bold" style="font-size:18px">${loja?.nome||"MixUp PDV"}</div>
<div class="center" style="font-size:10px">${loja?.endereco||""}</div>
<div class="line"></div>
<div class="center bold">RELATÓRIO DE CAIXA</div>
<div class="center">${hoje} — ${hora}</div>
<div class="line"></div>
<div class="row"><span>Operador:</span><span class="bold">${logado?.nome||"—"}</span></div>
<div class="row"><span>Abertura:</span><span>${fmtHora(logado?.inicio)}</span></div>
<div class="row"><span>Fundo de caixa:</span><span>${fmt(fundoVal)}</span></div>
<div class="line"></div>
<h2>VENDAS</h2>
<div class="row"><span>Qtd vendas:</span><span class="bold">${vendasSessao.length}</span></div>
<div class="row big"><span>TOTAL:</span><span>${fmt(fatSessao)}</span></div>
<div class="line"></div>
<h2>POR FORMA DE PAGAMENTO</h2>
<div class="row"><span>💵 Dinheiro:</span><span>${fmt(dinheiroSessao)}</span></div>
<div class="row"><span>📱 PIX:</span><span>${fmt(pixSessao)}</span></div>
<div class="row"><span>💳 Crédito:</span><span>${fmt(creditoSessao)}</span></div>
<div class="row"><span>💳 Débito:</span><span>${fmt(debitoSessao)}</span></div>
<div class="row"><span>🪙 Cashback:</span><span>${fmt(cashbackSessao)}</span></div>
<div class="line"></div>
<h2>CONFERÊNCIA DINHEIRO</h2>
<div class="row"><span>Fundo:</span><span>${fmt(fundoVal)}</span></div>
<div class="row"><span>+ Vendas dinheiro:</span><span>${fmt(dinheiroSessao)}</span></div>
<div class="row bold"><span>= Esperado:</span><span>${fmt(dinheiroEsperado)}</span></div>
<div class="line"></div>
<div class="center" style="margin-top:10px;font-size:10px">Impresso em ${hoje} ${hora}</div>
<script>window.onload=()=>{window.print();}</script>
</body></html>`;
    const w=window.open("","_blank","width=320,height=600");
    if(w){w.document.write(html);w.document.close();}
  };

  // ═══ IMPRIMIR RECIBO (VIA DO CLIENTE) ═══
  const imprimirRecibo=(dados)=>{
    const d=dados||{};
    const itens=d.itens||[];
    const hora=d.hora||new Date().toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});
    const data=d.data||new Date().toLocaleDateString("pt-BR");

    // ═══════════════════════════════════════════════════════════
    // PDV DESKTOP — manda direto pro servidor :3456 (100% silencioso)
    // PDV (Vendas/Mesas/Carros) imprime SÓ no caixa.
    // Pedidos delivery e App do Garçom é que mandam pra cozinha/bar.
    // ═══════════════════════════════════════════════════════════
    const isPDVDesktop = typeof window !== "undefined" && (window.__ELECTRON_PDV__ === true || !!window.__PRINT_SERVER__);
    if (isPDVDesktop) {
      const baseUrl = window.__PRINT_SERVER__ || "http://localhost:3456";
      const dadosPDV = {
        codigo: d.codigo || "",
        data: `${data} ${hora}`,
        operador: d.caixa || d.garcom || "",
        itens: itens.map(it => ({
          nome: it.nome || "",
          quantidade: Number(it.quantidade || 1),
          preco: Number(it.preco_unitario || it.preco || 0),
          subtotal: Number(it.preco_total || ((it.preco_unitario || it.preco || 0) * (it.quantidade || 1)))
        })),
        subtotal: Number(d.subtotal || 0),
        desconto: Number(d.desconto || 0),
        total: Number(d.total || 0),
        forma_pagamento: (d.forma || "").toUpperCase(),
        valor_recebido: Number(d.recebido || 0),
        troco: Number(d.troco || 0)
      };

      // PDV imprime APENAS no caixa (recibo do cliente)
      // Não imprime cozinha/bar porque os itens já foram feitos antes
      fetch(baseUrl + "/recibo", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dadosPDV)
      }).catch(()=>{});

      return; // não abre popup
    }

    // ═══════════════════════════════════════════════════════════
    // FALLBACK NAVEGADOR — abre popup com window.print() (legado)
    // ═══════════════════════════════════════════════════════════
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Recibo</title>
<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:'Courier New',monospace;font-size:12px;width:300px;padding:10px;color:#000}
.center{text-align:center}.bold{font-weight:bold}.line{border-bottom:1px dashed #000;margin:6px 0}
.row{display:flex;justify-content:space-between}.big{font-size:16px;font-weight:900}
.item{display:flex;justify-content:space-between;padding:2px 0;font-size:11px}
.item-nome{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
</style></head><body>
<div class="center bold" style="font-size:18px">${loja?.nome||"MixUp"}</div>
<div class="center" style="font-size:10px">${loja?.endereco||""}</div>
${loja?.telefone?`<div class="center" style="font-size:10px">Tel: ${loja.telefone}</div>`:""}
<div class="line"></div>
<div class="center bold" style="font-size:13px">CUPOM NÃO FISCAL</div>
<div class="row"><span>Data:</span><span>${data} ${hora}</span></div>
<div class="row"><span>Código:</span><span class="bold">${d.codigo||""}</span></div>
${d.local?`<div class="row"><span>Local:</span><span>${d.local}</span></div>`:""}
${d.caixa?`<div class="row"><span>Caixa:</span><span>${d.caixa}</span></div>`:""}
${d.garcom?`<div class="row"><span>Garçom:</span><span>${d.garcom}</span></div>`:""}
<div class="line"></div>
<div class="bold" style="margin-bottom:4px">ITENS</div>
${itens.map(it=>`<div class="item"><span class="item-nome">${it.quantidade||1}x ${it.nome}</span><span style="font-weight:700;min-width:60px;text-align:right">R$ ${(parseFloat(it.preco_total)||0).toFixed(2).replace(".",",")}</span></div>`).join("")}
<div class="line"></div>
${d.desconto>0?`<div class="row"><span>Subtotal:</span><span>R$ ${(d.subtotal||0).toFixed(2).replace(".",",")}</span></div><div class="row" style="color:#c00"><span>Desconto:</span><span>- R$ ${(d.desconto||0).toFixed(2).replace(".",",")}</span></div>`:""}
<div class="row big"><span>TOTAL:</span><span>R$ ${(d.total||0).toFixed(2).replace(".",",")}</span></div>
<div class="row"><span>Pagamento:</span><span class="bold">${(d.forma||"").toUpperCase()}</span></div>
${d.troco>0.01?`<div class="row"><span>Troco:</span><span class="bold">R$ ${d.troco.toFixed(2).replace(".",",")}</span></div>`:""}
<div class="line"></div>
<div class="center" style="margin-top:6px;font-size:10px">Obrigado pela preferência!</div>
<div class="center" style="font-size:9px;margin-top:2px">${data} ${hora}</div>
<script>window.onload=()=>{window.print();}</script>
</body></html>`;
    const w=window.open("","_blank","width=320,height=600");
    if(w){w.document.write(html);w.document.close();}
  };

  // Reimprimir a partir de um pedido do relatório
  const reimprimirRecibo=(pedido)=>{
    const itens=(pedido.itens||[]).length>0?pedido.itens:[{nome:pedido.observacao||"Venda PDV",quantidade:1,preco_total:valorReal(pedido)}];
    imprimirRecibo({
      codigo:pedido.codigo||"",
      data:pedido.criado_em?new Date(pedido.criado_em).toLocaleDateString("pt-BR"):"",
      hora:pedido.criado_em?new Date(pedido.criado_em).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}):"",
      local:pedido.endereco_entrega||"",
      caixa:pedido.caixa_nome||"",
      garcom:pedido.garcom_nome||"",
      itens:itens,
      subtotal:valorReal(pedido),
      desconto:parseFloat(pedido.desconto)||0,
      total:valorReal(pedido),
      forma:pedido.forma_pagamento||"",
      troco:0,
    });
  };
  const salvarUsuario=async()=>{
    if(!formUsuario.nome.trim()){notify("Nome obrigatório",false);return;}
    if(!formUsuario.id&&!formUsuario.senha.trim()){notify("Senha obrigatória",false);return;}
    setUsuarioLoading(true);
    let apiOk=false;
    let apiId=null;
    // ID local (timestamp) não deve ir pra API — só IDs do banco (pequenos)
    const isLocalId=formUsuario.id&&formUsuario.id>1000000000;
    const apiPayload={acao:"salvar",loja_id:lojaId||1,nome:formUsuario.nome,tipo:formUsuario.tipo||"caixa",senha:formUsuario.senha||undefined};
    if(formUsuario.id&&!isLocalId)apiPayload.id=formUsuario.id;
    try{
      const r=await post("pdv_usuarios",apiPayload);
      if(r.ok||r.sucesso||r.id||r.dados){
        apiOk=true;
        apiId=r.id||r.dados?.id||null;
        notify(formUsuario.id&&!isLocalId?"Atualizado!":"Cadastrado!");
      }else{
        notify("API: "+(r.erro||r.mensagem||"Erro")+" — salvo local",false);
      }
    }catch(e){
      console.log("PDV salvar erro:",e.message);
      notify("API indisponível — salvo local");
    }
    // Salvar/atualizar localStorage
    const local=getLocalUsers();
    if(formUsuario.id){
      const idx=local.findIndex(u=>String(u.id)===String(formUsuario.id));
      if(idx>=0){
        local[idx]={...local[idx],nome:formUsuario.nome,tipo:formUsuario.tipo};
        if(apiId)local[idx].id=apiId; // Atualizar ID local com ID do banco
      }else{
        local.push({id:apiId||Date.now(),nome:formUsuario.nome,tipo:formUsuario.tipo||"caixa",ativo:1,loja_id:lojaId||1});
      }
    }else{
      local.push({id:apiId||Date.now(),nome:formUsuario.nome,tipo:formUsuario.tipo||"caixa",ativo:1,loja_id:lojaId||1});
    }
    saveLocalUsers(local);
    setFormUsuario({id:null,nome:"",senha:"",tipo:configAba==="garcons"?"garcom":"caixa"});
    await carregarUsuarios();
    setUsuarioLoading(false);
  };
  const excluirUsuario=async(id)=>{
    if(!window.confirm("Excluir?"))return;
    const isLocalId=id&&id>1000000000;
    if(!isLocalId){try{await post("pdv_usuarios",{acao:"excluir",id,loja_id:lojaId||1});}catch{}}
    const local=getLocalUsers().filter(u=>String(u.id)!==String(id));
    saveLocalUsers(local);
    notify("Excluído!");
    await carregarUsuarios();
  };

  // ═══ COMANDA ═══
  const resetPag=()=>{setModoPag("rapido");setPagForma(null);setPagRecebido("");setPag({dinheiro:"",pix:"",credito:"",debito:"",cashback:""});setDesconto("");setDescontoTipo("real");setCambio(c=>({...c,pyg:"",usd:""}));setShowPagamento(false);};
  const abrirItem=(tipo,n,garcom)=>{const m=getItem(tipo,n);setAtivoNum(n);setAtivoTipo(tipo);setComanda(m.itens||[]);setObs(m.obs||"");setGarcomAtivo(garcom||m.garcom||null);resetPag();setComandaAberta(true);setProdSel(0);setTimeout(()=>buscaRef.current?.focus(),100);};
  const pedirGarcom=(tipo,n)=>{if(garcons.length>0&&itemSt(tipo,n)==="livre"){setGarcomPendente({tipo,n});setShowGarcomModal(true);}else{abrirItem(tipo,n,null);}};
  const selecionarGarcom=(g)=>{setShowGarcomModal(false);if(garcomPendente){abrirItem(garcomPendente.tipo,garcomPendente.n,g);setGarcomPendente(null);}};
  const abrirVendaDireta=()=>{setAtivoNum(null);setAtivoTipo("venda");setComanda([]);setObs("");setGarcomAtivo(null);resetPag();setComandaAberta(false);setProdSel(0);setTimeout(()=>buscaRef.current?.focus(),100);};
  const salvarComanda=()=>{if(ativoNum===null||!ativoTipo||ativoTipo==="venda")return;const st=getStore(ativoTipo);const m=getItem(ativoTipo,ativoNum);setStore(ativoTipo,{...st,[ativoNum]:{...m,itens:comanda,obs,garcom:garcomAtivo,status:comanda.filter(i=>!i.cancelado).length>0?"ocupada":"livre",abertura:m.abertura||(comanda.length>0?new Date().toISOString():null)}});};
  const voltarGrid=()=>{if(ativoTipo&&ativoTipo!=="venda")salvarComanda();setComandaAberta(false);setAtivoNum(null);setAtivoTipo(null);setBusca("");setCatAtiva("todos");};
  const adicionarItem=(prod)=>{const preco=parseFloat(prod.preco||prod.valor||0);setComanda(prev=>[...prev,{uid:UID(),produto_id:prod.id,codigo:prod.codigo||prod.id,nome:prod.nome,quantidade:1,preco_unitario:preco,preco_total:preco,adicionais:"",cancelado:false}]);setItemSel(null);notify(prod.nome+" ✓");setBusca("");setProdSel(0);setTimeout(()=>buscaRef.current?.focus(),50);};
  const removerItem=(uid)=>setComanda(p=>p.map(i=>i.uid===uid?{...i,cancelado:true}:i));
  const alterarQtd=(uid,d)=>setComanda(p=>p.map(i=>{if(i.uid!==uid||i.cancelado)return i;const q=Math.max(1,i.quantidade+d);return{...i,quantidade:q,preco_total:i.preco_unitario*q};}));

  // ═══ CÁLCULOS ═══
  const itensAtivos=comanda.filter(i=>!i.cancelado);
  const subtotal=itensAtivos.reduce((s,i)=>s+i.preco_total,0);
  const descontoVal=descontoTipo==="pct"?subtotal*pv(desconto)/100:pv(desconto);
  const total=Math.max(0,subtotal-descontoVal);
  const totalGs=fmtGs(total,cambio.taxaPyg);
  const cambioReais=pv(cambio.pyg)/(pv(cambio.taxaPyg)||1)+pv(cambio.usd)*(pv(cambio.taxaUsd)||1);
  const totalPagoMisto=Object.values(pag).reduce((s,v)=>s+pv(v),0)+cambioReais;
  const diferenca=(modoPag==="misto"?totalPagoMisto:pv(pagRecebido)+cambioReais)-total;
  const prodsFilt=produtos.filter(p=>{const cOk=catAtiva==="todos"||(p.categoria||p.categoria_nome||"Outros")===catAtiva;const b=busca.toLowerCase();return cOk&&(!b||(p.nome||"").toLowerCase().includes(b)||String(p.codigo||"").includes(b)||String(p.id).includes(b));});

  // ═══ FINALIZAR ═══
  const finalizar=async()=>{
    if(itensAtivos.length===0){notify("Sem itens",false);return;}
    let forma="dinheiro";
    if(modoPag==="rapido"){if(!pagForma){notify("Selecione forma",false);return;}forma=pagForma;if(forma==="dinheiro"&&pv(pagRecebido)<total&&cambioReais<0.01){notify("Informe valor",false);return;}}
    else{const fs=Object.entries(pag).filter(([,v])=>pv(v)>0).map(([k])=>k);if(fs.length===0&&cambioReais<0.01){notify("Informe pagamento",false);return;}forma=fs.length===1?fs[0]:fs.join("+")||"dinheiro";if(diferenca<-0.01){notify("Insuficiente!",false);return;}}
    setLoading(true);
    try{
      const label=ativoTipo==="carro"?"CARRO "+ativoNum:ativoTipo==="mesa"?"MESA "+ativoNum:ativoTipo==="comanda"?"COMANDA "+ativoNum:"BALCÃO";
      const codigo="PDV"+String(Date.now()).slice(-6);
      const obsC=[`[PDV - ${label}]`,garcomAtivo?`[Garçom: ${garcomAtivo.nome||garcomAtivo}]`:"",logado?`[Caixa: ${logado.nome}]`:"",obs||"",cambioReais>0?"[CÂMBIO]":"",diferenca>0.01?`[TROCO: R$ ${diferenca.toFixed(2)}]`:""].filter(Boolean).join(" ");
      // Calcular cashback usado: rapido=total, misto=valor do campo cashback
      const cbUsado=modoPag==="rapido"&&forma==="cashback"?total:pv(pag.cashback);
      await post("pdv",{acao:"criar_pedido",codigo,cliente_id:1,loja_id:lojaId||1,status:"entregue",subtotal:subtotal.toFixed(2),taxa_entrega:"0",desconto:descontoVal.toFixed(2),total:total.toFixed(2),forma_pagamento:forma,cashback_usado:cbUsado.toFixed(2),endereco_entrega:label,observacao:obsC,canal:"pdv_interno",caixa_id:logado?.id||null,caixa_nome:logado?.nome||null,garcom_id:garcomAtivo?.id||null,garcom_nome:garcomAtivo?.nome||null,itens:itensAtivos.map(i=>({produto_id:i.produto_id,nome:i.nome,quantidade:i.quantidade,preco_unitario:i.preco_unitario.toFixed(2),preco_total:i.preco_total.toFixed(2),adicionais:i.adicionais||""})),mesa:ativoNum||0});
      notify("✅ "+label+" "+fmt(total));
      // Auto-imprimir recibo do cliente
      imprimirRecibo({
        codigo,
        local:label,
        caixa:logado?.nome||"",
        garcom:garcomAtivo?.nome||"",
        itens:itensAtivos.map(i=>({nome:i.nome,quantidade:i.quantidade,preco_total:i.preco_total})),
        subtotal,
        desconto:descontoVal,
        total,
        forma,
        troco:diferenca>0.01?diferenca:0,
      });
      if(ativoTipo==="mesa"||ativoTipo==="carro"||ativoTipo==="comanda"){const st=getStore(ativoTipo);st[ativoNum]={status:"livre",itens:[],abertura:null,obs:"",garcom:null};setStore(ativoTipo,{...st});}
      setComanda([]);setObs("");resetPag();onRefresh?.();
      if(ativoTipo==="venda")abrirVendaDireta();else{setComandaAberta(false);setAtivoNum(null);setAtivoTipo(null);}
    }catch(e){notify("Erro: "+e.message,false);}
    setLoading(false);
  };
  // ═══ RELATÓRIO ═══
  const carregarRelatorio=async(filtroOverride)=>{setCxLoading(true);try{const f=filtroOverride||cxFiltro;const p={loja_id:lojaId||1,acao:"relatorio_pdv"};if(f.de)p.data_de=f.de;if(f.ate)p.data_ate=f.ate;if(f.caixa)p.caixa_nome=f.caixa;if(f.garcom)p.garcom_nome=f.garcom;if(f.forma)p.forma_pagamento=f.forma;if(f.canal)p.canal=f.canal;const r=await get("pedidos",p);setCxRelatorio(r.dados||r.pedidos||(Array.isArray(r)?r:[]));} catch{setCxRelatorio([]);}setCxLoading(false);};
  useEffect(()=>{if(abaAtiva==="caixa"&&logado&&!logado._temp){
    // Pré-filtrar pelo operador logado e data de hoje
    const hoje=new Date().toISOString().slice(0,10);
    const filtroInicial={de:hoje,ate:hoje,caixa:logado.nome||"",garcom:"",forma:"",canal:""};
    setCxFiltro(filtroInicial);
    carregarRelatorio(filtroInicial);
  }},[abaAtiva]);

  // ═══ TECLADO ═══
  useEffect(()=>{
    if(!logado||logado._temp)return;
    const h=(e)=>{
      if((abaAtiva==="mesas"||abaAtiva==="carros"||abaAtiva==="comandas")&&!comandaAberta){
        const max=abaAtiva==="carros"?totalCarros:abaAtiva==="comandas"?totalComandas:totalMesas;const tipo=abaAtiva==="carros"?"carro":abaAtiva==="comandas"?"comanda":"mesa";
        if(e.key==="ArrowRight"){e.preventDefault();setSelNum(s=>Math.min(s+1,max));}
        else if(e.key==="ArrowLeft"){e.preventDefault();setSelNum(s=>Math.max(s-1,1));}
        else if(e.key==="ArrowDown"){e.preventDefault();setSelNum(s=>Math.min(s+5,max));}
        else if(e.key==="ArrowUp"){e.preventDefault();setSelNum(s=>Math.max(s-5,1));}
        else if(e.key==="Enter"){e.preventDefault();pedirGarcom(tipo,selNum);}
        else if(e.key==="Escape"){e.preventDefault();setAbaAtiva("vendas");abrirVendaDireta();}
        return;
      }
      if(abaAtiva==="vendas"||comandaAberta){
        if(document.activeElement===buscaRef.current){
          if(e.key==="ArrowDown"){e.preventDefault();setProdSel(i=>Math.min(i+1,prodsFilt.length-1));}
          else if(e.key==="ArrowUp"){e.preventDefault();setProdSel(i=>Math.max(i-1,0));}
          else if(e.key==="Enter"&&prodsFilt.length>0){e.preventDefault();adicionarItem(prodsFilt[prodSel]);}
          else if(e.key==="Escape"){e.preventDefault();setBusca("");buscaRef.current?.blur();}
          else if(e.key==="F9"){e.preventDefault();if(pagForma)finalizar();else if(itensAtivos.length>0)setPagForma("dinheiro");}
          return;
        }
        if(document.activeElement===pagRef.current){if(e.key==="Escape"){e.preventDefault();pagRef.current?.blur();}else if(e.key==="Enter"||e.key==="F9"){e.preventDefault();finalizar();}return;}
        if(document.activeElement?.tagName==="INPUT"||document.activeElement?.tagName==="TEXTAREA"||document.activeElement?.tagName==="SELECT"){if(e.key==="F9"){e.preventDefault();if(pagForma)finalizar();}return;}
        if(e.key==="Escape"){e.preventDefault();if(showPagamento)setShowPagamento(false);else if(comandaAberta)voltarGrid();}
        else if(e.key==="F2"){e.preventDefault();if(comandaAberta)voltarGrid();}
        else if(e.key==="F9"){e.preventDefault();if(pagForma)finalizar();else if(itensAtivos.length>0){setShowPagamento(true);setPagForma("dinheiro");}}
        else if(e.key==="/"||e.key==="F3"){e.preventDefault();buscaRef.current?.focus();}
        else if(e.key==="Delete"&&itemSel){e.preventDefault();removerItem(itemSel);}
        else if(["1","2","3","4","5"].includes(e.key)&&!e.ctrlKey&&showPagamento){e.preventDefault();const fp=FORMAS[parseInt(e.key)-1];if(fp&&itensAtivos.length>0){setPagForma(fp.k);setModoPag("rapido");if(fp.k==="dinheiro"){setPagRecebido("");setTimeout(()=>pagRef.current?.focus(),50);}else{setPagRecebido(total.toFixed(2));setTimeout(()=>finalizar(),100);}}}
        else if(e.key==="6"&&!e.ctrlKey&&showPagamento){e.preventDefault();setModoPag(modoPag==="misto"?"rapido":"misto");setPagForma(null);}
        else if((e.key==="m"||e.key==="M")&&showPagamento){e.preventDefault();setModoPag(modoPag==="misto"?"rapido":"misto");setPagForma(null);}
        else if(e.key==="+"&&itemSel){e.preventDefault();alterarQtd(itemSel,1);}
        else if(e.key==="-"&&itemSel){e.preventDefault();alterarQtd(itemSel,-1);}
      }
    };
    window.addEventListener("keydown",h);return()=>window.removeEventListener("keydown",h);
  });
  useEffect(()=>{if(logado&&!logado._temp)abrirVendaDireta();},[logado]);

  const ABAS_TODAS=[{k:"vendas",l:"Vendas",ico:"🛒",cor:DC.green},{k:"mesas",l:"Mesas",ico:"🍽",cor:DC.accent},{k:"carros",l:"Carros",ico:"🚗",cor:DC.blue},{k:"comandas",l:"Comandas",ico:"📋",cor:DC.purple},{k:"caixa",l:"Caixa",ico:"💰",cor:DC.purple},{k:"pedidos",l:"Pedidos",ico:"🛵",cor:DC.orange,page:"pedidos"}];
  const ABAS=ABAS_TODAS.filter(a=>{
    if(a.k==="mesas"&&!usaMesa)return false;
    if(a.k==="carros"&&!usaCarro)return false;
    if(a.k==="comandas"&&!usaComanda)return false;
    return true;
  });
  const trocarAba=(k)=>{if(ativoTipo&&ativoTipo!=="venda")salvarComanda();setAbaAtiva(k);setComandaAberta(false);setBusca("");setCatAtiva("todos");setShowPagamento(false);if(k==="vendas")abrirVendaDireta();else{setAtivoNum(null);setAtivoTipo(null);setSelNum(1);}};
  const ATALHOS=[
    {l:"/ Buscar",cor:DC.textSoft,fn:()=>buscaRef.current?.focus()},
    {l:"F2 Voltar",cor:DC.yellow,fn:()=>{if(comandaAberta)voltarGrid();}},
    {l:"F9 Pagar",cor:DC.green,fn:()=>{if(pagForma)finalizar();else if(itensAtivos.length>0){setShowPagamento(true);if(!pagForma)setPagForma("dinheiro");}}},
    {l:"Del Remover",cor:DC.accent,fn:()=>{if(itemSel)removerItem(itemSel);}},
    {l:"M Misto",cor:DC.purple,fn:()=>{if(showPagamento){setModoPag(modoPag==="misto"?"rapido":"misto");setPagForma(null);}}},
    {l:"Esc",cor:DC.textMuted,fn:()=>{if(showPagamento)setShowPagamento(false);else if(comandaAberta)voltarGrid();}},
    {l:"🖨 Imprimir",cor:DC.cyan,fn:()=>imprimirRelatorio()},
    {l:"📉 Sangria",cor:DC.orange,fn:()=>{setMovValor("");setMovMotivo("");setShowMovModal("sangria");}},
    {l:"📈 Suprimento",cor:DC.blue,fn:()=>{setMovValor("");setMovMotivo("");setShowMovModal("suprimento");}},
    {l:"⚙ Config",cor:DC.textMuted,fn:()=>setShowConfig(true)},
  ];

  /* ═══════════════════════════════
     TELA DE LOGIN / ABERTURA CAIXA
  ═══════════════════════════════ */
  if(!logado||logado._temp){
    // Se está na etapa FUNDO (já autenticou ou bypass)
    if(etapaLogin==="fundo"&&logado?._temp){
      return(
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"calc(100vh - 32px)",background:`linear-gradient(135deg, ${DC.bg} 0%, #141825 100%)`,color:DC.text}}>
          <div style={{width:400,background:DC.card,borderRadius:20,padding:36,border:`1px solid ${DC.border}`,boxShadow:`0 20px 80px rgba(0,0,0,.5)`}}>
            <div style={{textAlign:"center",marginBottom:24}}>
              <div style={{fontSize:20,fontWeight:800}}>💰 Abertura de Caixa</div>
              <div style={{fontSize:13,color:DC.textMuted,marginTop:4}}>Operador: <b style={{color:DC.green}}>{logado?.nome}</b></div>
              <div style={{fontSize:11,color:DC.textMuted}}>{new Date().toLocaleDateString("pt-BR")} — {new Date().toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}</div>
            </div>
            <div style={{marginBottom:20}}>
              <label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:8}}>Fundo de Caixa (troco inicial em dinheiro)</label>
              <input type="text" value={fundoCaixa} onChange={e=>setFundoCaixa(e.target.value.replace(/[^\d.,]/g,""))}
                onKeyDown={e=>{if(e.key==="Enter")abrirCaixa();}}
                style={{...sInput,width:"100%",fontSize:28,fontWeight:900,textAlign:"center",color:DC.green,fontFamily:mono,padding:"14px"}} placeholder="0,00" autoFocus/>
              <div style={{display:"flex",gap:6,marginTop:8}}>
                {[0,50,100,200,500].map(v=><div key={v} onClick={()=>setFundoCaixa(v.toFixed(2))} style={{flex:1,padding:"8px",borderRadius:6,border:`1px solid ${DC.border}`,textAlign:"center",fontSize:12,color:DC.textMuted,cursor:"pointer",background:DC.bgSoft,fontWeight:600}}>{v===0?"R$ 0":"R$ "+v}</div>)}
              </div>
            </div>
            <button onClick={abrirCaixa} style={{...sBtn(DC.green,"#fff"),width:"100%",padding:16,fontSize:16,borderRadius:12}}>
              Abrir Caixa
            </button>
          </div>
        </div>
      );
    }

    // Tela de seleção/login
    return(
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"calc(100vh - 32px)",background:`linear-gradient(135deg, ${DC.bg} 0%, #141825 100%)`,color:DC.text}}>
        {toast&&<div style={{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:9999,background:toast.ok?DC.green:DC.accent,color:"#fff",padding:"10px 28px",borderRadius:10,fontWeight:700,fontSize:14}}>{toast.msg}</div>}
        <div style={{width:400,background:DC.card,borderRadius:20,padding:36,border:`1px solid ${DC.border}`,boxShadow:`0 20px 80px rgba(0,0,0,.5)`}}>
          <div style={{textAlign:"center",marginBottom:28}}>
            {(loja?.logo||loja?.imagem||loja?.foto)?<img src={loja.logo||loja.imagem||loja.foto} alt="" style={{height:50,maxWidth:160,objectFit:"contain",marginBottom:12}}/>
              :<div style={{fontSize:32,fontWeight:900,marginBottom:8}}><span style={{color:DC.accent}}>Mix</span><span style={{color:DC.green}}>Up</span></div>}
            <div style={{fontSize:16,fontWeight:800}}>Frente de Caixa</div>
            <div style={{fontSize:12,color:DC.textMuted,marginTop:4}}>{loja?.nome||"PDV"} · {new Date().toLocaleDateString("pt-BR")}</div>
          </div>

          {!usuariosCarregados?(
            <div style={{textAlign:"center",padding:20,color:DC.textMuted}}>Carregando...</div>
          ):caixas.length>0?(
            <>
              <div style={{marginBottom:16}}>
                <label style={{fontSize:11,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Operador</label>
                <select value={loginUsuarioId} onChange={e=>setLoginUsuarioId(e.target.value)} style={{...sInput,width:"100%",fontSize:14,fontWeight:600}}>
                  <option value="">Selecione...</option>
                  {caixas.map(u=><option key={u.id} value={u.id}>{u.nome} ({u.tipo})</option>)}
                </select>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:11,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Senha</label>
                <input type="password" value={loginSenha} onChange={e=>setLoginSenha(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")fazerLogin();}} style={{...sInput,width:"100%",fontSize:18,fontWeight:800,textAlign:"center",letterSpacing:6}} placeholder="••••" autoFocus/>
              </div>
              {loginErro&&<div style={{padding:"8px 12px",borderRadius:8,background:DC.accentSoft,color:DC.accent,fontSize:12,fontWeight:600,marginBottom:12,textAlign:"center"}}>{loginErro}</div>}
              <button onClick={fazerLogin} disabled={loginLoading} style={{...sBtn(DC.green,"#fff"),width:"100%",padding:14,fontSize:15,borderRadius:12,opacity:loginLoading?0.6:1}}>{loginLoading?"Verificando...":"Entrar"}</button>
            </>
          ):(
            <div style={{textAlign:"center"}}>
              <div style={{padding:16,borderRadius:10,background:DC.bgSoft,border:`1px solid ${DC.border}`,marginBottom:16}}>
                <div style={{fontSize:13,color:DC.textMuted,marginBottom:8}}>Nenhum operador cadastrado ainda.</div>
                <div style={{fontSize:12,color:DC.textSoft}}>Use "Entrar como Admin" para cadastrar caixas e garçons nas configurações.</div>
              </div>
            </div>
          )}

          {/* Botão bypass — sempre visível */}
          <div onClick={entrarSemLogin} style={{textAlign:"center",padding:"10px",marginTop:12,borderRadius:8,border:`1px dashed ${DC.border}`,color:DC.textMuted,fontSize:12,cursor:"pointer",transition:"all .15s"}}
            onMouseOver={e=>{e.currentTarget.style.borderColor=DC.orange;e.currentTarget.style.color=DC.orange;}}
            onMouseOut={e=>{e.currentTarget.style.borderColor=DC.border;e.currentTarget.style.color=DC.textMuted;}}>
            Entrar como Admin (sem senha)
          </div>
        </div>
      </div>
    );
  }

  /* ═══════════════════════════════
     RENDER PRINCIPAL (LOGADO)
  ═══════════════════════════════ */
  return(
    <div style={{display:"flex",flexDirection:"column",height:"calc(100vh - 32px)",overflow:"hidden",background:DC.bg,color:DC.text,fontFamily:"'Segoe UI',sans-serif"}}>
      {toast&&<div style={{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:9999,background:toast.ok?DC.green:DC.accent,color:"#fff",padding:"10px 28px",borderRadius:10,fontWeight:700,fontSize:14,whiteSpace:"nowrap",boxShadow:`0 4px 20px ${toast.ok?DC.greenGlow:DC.accentGlow}`}}>{toast.msg}</div>}

      {/* TOP BAR */}
      <div style={{display:"flex",alignItems:"stretch",height:48,background:DC.bgSoft,borderBottom:`1px solid ${DC.border}`,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",padding:"0 16px",gap:8,borderRight:`1px solid ${DC.border}`}}>
          {(loja?.logo||loja?.imagem||loja?.foto)?<img src={loja.logo||loja.imagem||loja.foto} alt="" style={{height:28,maxWidth:100,objectFit:"contain"}}/>:<span style={{fontWeight:900,fontSize:18}}><span style={{color:DC.accent}}>Mix</span><span style={{color:DC.green}}>Up</span></span>}
          <span style={{fontSize:10,color:DC.textMuted,fontWeight:600}}>PDV</span>
        </div>
        {ABAS.map(ab=><div key={ab.k} onClick={()=>ab.page?(goTo&&goTo(ab.page)):trocarAba(ab.k)} style={{flex:"0 0 auto",display:"flex",alignItems:"center",gap:6,padding:"0 22px",fontSize:13,fontWeight:abaAtiva===ab.k?800:600,color:abaAtiva===ab.k?DC.white:DC.textMuted,background:abaAtiva===ab.k?`${ab.cor}18`:"transparent",borderBottom:abaAtiva===ab.k?`3px solid ${ab.cor}`:"3px solid transparent",cursor:"pointer",transition:"all .15s"}}>
          <span style={{fontSize:16}}>{ab.ico}</span><span>{ab.l}</span>
        </div>)}
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:12,padding:"0 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:28,height:28,borderRadius:8,background:DC.greenSoft,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:900,color:DC.green}}>{(logado?.nome||"?")[0].toUpperCase()}</div>
            <div><div style={{fontSize:11,fontWeight:700}}>{logado?.nome}</div><div style={{fontSize:9,color:DC.textMuted}}>Desde {fmtHora(logado?.inicio)} · Fundo {fmt(fundoVal)}</div></div>
          </div>
          <span style={{fontSize:11,color:DC.textMuted}}>{new Date().toLocaleDateString("pt-BR",{weekday:"short",day:"2-digit",month:"short"})}</span>
          <div onClick={()=>{setFechSenha("");setFechSenhaErro("");setShowFechamento(true);}} style={{cursor:"pointer",fontSize:11,color:DC.accent,fontWeight:700,padding:"5px 10px",borderRadius:6,border:`1px solid ${DC.accent}40`}}>Fechar Caixa</div>
        </div>
      </div>

      {/* CONTEÚDO — mesmo de antes, reutilizando componentes */}
      <div style={{flex:1,display:"flex",minHeight:0}}>
        {abaAtiva==="vendas"&&<><ProdGrid produtos={produtos} prodsFilt={prodsFilt} cats={categorias} catAtiva={catAtiva} setCatAtiva={setCatAtiva} busca={busca} setBusca={setBusca} prodSel={prodSel} setProdSel={setProdSel} add={adicionarItem} buscaRef={buscaRef}/><Ticket comanda={comanda} setComanda={setComanda} itemSel={itemSel} setItemSel={setItemSel} altQtd={alterarQtd} rem={removerItem} ativoTipo={ativoTipo||"venda"} ativoNum={ativoNum} garcom={garcomAtivo} itensAtivos={itensAtivos} subtotal={subtotal} total={total} totalGs={totalGs} desconto={desconto} setDesconto={setDesconto} descontoTipo={descontoTipo} setDescontoTipo={setDescontoTipo} descontoVal={descontoVal} showPag={showPagamento} setShowPag={setShowPagamento} modoPag={modoPag} setModoPag={setModoPag} pagForma={pagForma} setPagForma={setPagForma} pagRec={pagRecebido} setPagRec={setPagRecebido} pagRef={pagRef} pag={pag} setPag={setPag} tpm={totalPagoMisto} dif={diferenca} loading={loading} fin={finalizar} notify={notify}/></>}
        {abaAtiva==="mesas"&&!comandaAberta&&<MesaGrid tipo="mesa" label="Mesa" img={null} cor={DC.accent} total_={totalMesas} selNum={selNum} itemSt={itemSt} itemTot={itemTot} itemTmp={itemTmp} itemQtd={itemQtd} abrir={pedirGarcom} labels={labels} getCliente={getCliente} onAbrirLabels={setModalLabelsTipo}/>}
        {abaAtiva==="carros"&&!comandaAberta&&<MesaGrid tipo="carro" label="Carro" img={null} cor={DC.blue} total_={totalCarros} selNum={selNum} itemSt={itemSt} itemTot={itemTot} itemTmp={itemTmp} itemQtd={itemQtd} abrir={pedirGarcom} labels={labels} getCliente={getCliente} onAbrirLabels={setModalLabelsTipo}/>}
        {abaAtiva==="comandas"&&!comandaAberta&&<MesaGrid tipo="comanda" label="Comanda" img={null} cor={DC.purple} total_={totalComandas} selNum={selNum} itemSt={itemSt} itemTot={itemTot} itemTmp={itemTmp} itemQtd={itemQtd} abrir={pedirGarcom} labels={labels} getCliente={getCliente} onAbrirLabels={setModalLabelsTipo}/>}
        {(abaAtiva==="mesas"||abaAtiva==="carros"||abaAtiva==="comandas")&&comandaAberta&&<>
          <ProdGrid produtos={produtos} prodsFilt={prodsFilt} cats={categorias} catAtiva={catAtiva} setCatAtiva={setCatAtiva} busca={busca} setBusca={setBusca} prodSel={prodSel} setProdSel={setProdSel} add={adicionarItem} buscaRef={buscaRef}
            header={<div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <button onClick={voltarGrid} style={{...sBtn(DC.card,DC.textSoft),border:`1px solid ${DC.border}`,padding:"7px 14px",fontSize:12}}>← Voltar</button>
              <div style={{fontSize:15,fontWeight:800,color:ativoTipo==="carro"?DC.blue:ativoTipo==="comanda"?DC.purple:DC.accent,display:"flex",alignItems:"center",gap:6}}>
                {ativoTipo==="carro"?"🚗":ativoTipo==="comanda"?"📋":"🍽"} {nomeMesa(ativoTipo, ativoNum)}
              </div>
              <input
                type="text"
                placeholder="👤 Nome do cliente"
                maxLength={50}
                defaultValue={getCliente(ativoTipo, ativoNum)}
                onBlur={(ev)=>{const v=ev.target.value.trim();if(v!==getCliente(ativoTipo,ativoNum))setCliente(ativoTipo,ativoNum,v);}}
                onKeyDown={(ev)=>{if(ev.key==="Enter")ev.target.blur();}}
                style={{...sInput,padding:"6px 12px",fontSize:12,width:180}}
              />
              {garcomAtivo&&<span style={{fontSize:11,color:DC.textMuted,background:DC.card,padding:"3px 10px",borderRadius:8}}>👤 {garcomAtivo.nome}</span>}
              {ativoNum&&itemTmp(ativoTipo,ativoNum)&&<span style={{fontSize:11,color:DC.textMuted,background:DC.card,padding:"3px 10px",borderRadius:8}}>⏱ {itemTmp(ativoTipo,ativoNum)}</span>}
            </div>}/>
          <Ticket comanda={comanda} setComanda={setComanda} itemSel={itemSel} setItemSel={setItemSel} altQtd={alterarQtd} rem={removerItem} ativoTipo={ativoTipo} ativoNum={ativoNum} garcom={garcomAtivo} itensAtivos={itensAtivos} subtotal={subtotal} total={total} totalGs={totalGs} desconto={desconto} setDesconto={setDesconto} descontoTipo={descontoTipo} setDescontoTipo={setDescontoTipo} descontoVal={descontoVal} showPag={showPagamento} setShowPag={setShowPagamento} modoPag={modoPag} setModoPag={setModoPag} pagForma={pagForma} setPagForma={setPagForma} pagRec={pagRecebido} setPagRec={setPagRecebido} pagRef={pagRef} pag={pag} setPag={setPag} tpm={totalPagoMisto} dif={diferenca} loading={loading} fin={finalizar} notify={notify}/>
        </>}
        {abaAtiva==="caixa"&&<CaixaTab orders={orders} cambio={cambio} cxFiltro={cxFiltro} setCxFiltro={setCxFiltro} cxRelatorio={cxRelatorio} cxLoading={cxLoading} carregarRelatorio={carregarRelatorio} usuarios={usuarios} logado={logado} vendasSessao={vendasSessao} fatSessao={fatSessao} dinheiroSessao={dinheiroSessao} pixSessao={pixSessao} creditoSessao={creditoSessao} debitoSessao={debitoSessao} cashbackSessao={cashbackSessao} fundoVal={fundoVal} dinheiroEsperado={dinheiroEsperado} imprimirRelatorio={imprimirRelatorio} reimprimirRecibo={reimprimirRecibo}/>}
      </div>

      {/* BOTTOM BAR */}
      <div style={{height:40,background:DC.bgSoft,borderTop:`1px solid ${DC.border}`,display:"flex",alignItems:"center",gap:0,padding:"0 8px",flexShrink:0,overflowX:"auto"}}>
        {ATALHOS.map((at,i)=><div key={i} onClick={at.fn} style={{display:"flex",alignItems:"center",gap:4,padding:"6px 12px",cursor:"pointer",borderRight:`1px solid ${DC.border}`,fontSize:11,fontWeight:600,color:at.cor,whiteSpace:"nowrap"}} onMouseOver={e=>{e.currentTarget.style.background=DC.card;}} onMouseOut={e=>{e.currentTarget.style.background="transparent";}}>{at.l}</div>)}
        <div style={{marginLeft:"auto",fontSize:10,color:DC.textMuted,padding:"0 8px"}}>Caixa: <b style={{color:DC.text}}>{logado?.nome}</b> · Desde {fmtHora(logado?.inicio)}</div>
      </div>

      {/* MODAL: Renomear mesas/carros/comandas (labels persistentes) */}
      <ModalLabels
        aberto={!!modalLabelsTipo}
        tipo={modalLabelsTipo||"mesa"}
        label={modalLabelsTipo==="carro"?"Carro":modalLabelsTipo==="comanda"?"Comanda":"Mesa"}
        total_={modalLabelsTipo==="carro"?totalCarros:modalLabelsTipo==="comanda"?totalComandas:totalMesas}
        labels={labels}
        onClose={()=>setModalLabelsTipo(null)}
        onSalvar={(novos)=>salvarLabels(modalLabelsTipo,novos)}
      />

      {/* MODAL: Sangria ou Suprimento */}
      {showMovModal&&<div onClick={()=>{if(!movLoading)setShowMovModal(null);}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:970,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(6px)"}}>
        <div onClick={e=>e.stopPropagation()} style={{background:DC.card,borderRadius:18,padding:28,width:440,border:`1px solid ${showMovModal==="sangria"?DC.orange:DC.blue}`}}>
          <div style={{fontSize:20,fontWeight:900,marginBottom:6,color:showMovModal==="sangria"?DC.orange:DC.blue}}>
            {showMovModal==="sangria"?"📉 Registrar Sangria":"📈 Registrar Suprimento"}
          </div>
          <div style={{fontSize:12,color:DC.textMuted,marginBottom:18}}>
            {showMovModal==="sangria"?"Dinheiro que SAI da gaveta (pro cofre, banco, troco extra...)":"Dinheiro que ENTRA na gaveta (reforço, troco trocado, devolução...)"}
          </div>

          <label style={{fontSize:11,color:DC.textMuted,display:"block",marginBottom:4,fontWeight:600}}>Valor (R$)</label>
          <input value={movValor} onChange={e=>setMovValor(e.target.value.replace(/[^\d.,]/g,""))} placeholder="0,00" autoFocus
            style={{...sInput,width:"100%",fontSize:22,fontWeight:900,textAlign:"center",fontFamily:mono,color:showMovModal==="sangria"?DC.orange:DC.blue,marginBottom:14}}/>

          <label style={{fontSize:11,color:DC.textMuted,display:"block",marginBottom:4,fontWeight:600}}>Motivo *</label>
          <input value={movMotivo} onChange={e=>setMovMotivo(e.target.value)} placeholder={showMovModal==="sangria"?"Ex: Levado pro cofre, pagamento fornecedor...":"Ex: Reforço de troco, devolução cliente..."}
            maxLength={200}
            onKeyDown={e=>{if(e.key==="Enter"&&!movLoading)registrarMov();}}
            style={{...sInput,width:"100%",fontSize:14,marginBottom:18}}/>

          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>setShowMovModal(null)} disabled={movLoading} style={{...sBtn(DC.card,DC.textSoft),flex:1,border:`1px solid ${DC.border}`,padding:12}}>Cancelar</button>
            <button onClick={registrarMov} disabled={movLoading} style={{...sBtn(showMovModal==="sangria"?DC.orange:DC.blue,"#fff"),flex:2,padding:12,opacity:movLoading?.6:1}}>
              {movLoading?"Salvando...":(showMovModal==="sangria"?"📉 Confirmar Sangria":"📈 Confirmar Suprimento")}
            </button>
          </div>
        </div>
      </div>}

      {/* MODAL: Histórico de movimentações do turno */}
      {showHistMov&&<div onClick={()=>setShowHistMov(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:980,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(6px)"}}>
        <div onClick={e=>e.stopPropagation()} style={{background:DC.card,borderRadius:16,padding:24,width:520,maxHeight:"80vh",display:"flex",flexDirection:"column",border:`1px solid ${DC.border}`}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontSize:17,fontWeight:800}}>📋 Movimentações do turno</div>
            <div onClick={()=>setShowHistMov(false)} style={{cursor:"pointer",fontSize:18,color:DC.textMuted}}>✕</div>
          </div>
          <div style={{flex:1,overflowY:"auto",display:"flex",flexDirection:"column",gap:6}}>
            {movsSessao.length===0&&<div style={{padding:24,textAlign:"center",color:DC.textMuted,fontSize:13}}>Nenhuma movimentação ainda</div>}
            {movsSessao.map(m=>(
              <div key={m.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:DC.bgSoft,borderRadius:10,borderLeft:`3px solid ${m.tipo==="sangria"?DC.orange:DC.blue}`}}>
                <div style={{fontSize:18}}>{m.tipo==="sangria"?"📉":"📈"}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:m.tipo==="sangria"?DC.orange:DC.blue}}>{m.tipo==="sangria"?"Sangria":"Suprimento"} · {fmt(parseFloat(m.valor||0))}</div>
                  <div style={{fontSize:11,color:DC.textSoft,marginTop:1}}>{m.motivo}</div>
                  <div style={{fontSize:10,color:DC.textMuted,marginTop:1}}>{fmtHora(m.criado_em)} · {m.operador_nome||"—"}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:14,paddingTop:14,borderTop:`1px solid ${DC.border}`}}>
            <div style={{background:DC.bgSoft,borderRadius:8,padding:"8px 12px",borderLeft:`3px solid ${DC.blue}`}}>
              <div style={{fontSize:10,color:DC.textMuted}}>Total Suprimentos</div>
              <div style={{fontSize:15,fontWeight:800,color:DC.blue,fontFamily:mono}}>{fmt(totalSuprimentos)}</div>
            </div>
            <div style={{background:DC.bgSoft,borderRadius:8,padding:"8px 12px",borderLeft:`3px solid ${DC.orange}`}}>
              <div style={{fontSize:10,color:DC.textMuted}}>Total Sangrias</div>
              <div style={{fontSize:15,fontWeight:800,color:DC.orange,fontFamily:mono}}>{fmt(totalSangrias)}</div>
            </div>
          </div>
        </div>
      </div>}

      {/* MODAL GARÇOM */}
      {showGarcomModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:950,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(4px)"}} onClick={()=>{setShowGarcomModal(false);setGarcomPendente(null);}}>
        <div style={{background:DC.card,borderRadius:16,padding:24,width:340,border:`1px solid ${DC.border}`}} onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:16,fontWeight:800,marginBottom:16}}>👤 Selecionar Garçom</div>
          {garcons.map(g=><div key={g.id} onClick={()=>selecionarGarcom(g)} style={{padding:"12px 16px",borderRadius:10,border:`1px solid ${DC.border}`,background:DC.bgSoft,cursor:"pointer",fontSize:14,fontWeight:600,marginBottom:6,transition:"all .12s"}} onMouseOver={e=>{e.currentTarget.style.borderColor=DC.green;}} onMouseOut={e=>{e.currentTarget.style.borderColor=DC.border;}}>{g.nome}</div>)}
          <div onClick={()=>selecionarGarcom(null)} style={{padding:"10px 16px",borderRadius:10,border:`1px dashed ${DC.border}`,cursor:"pointer",fontSize:12,color:DC.textMuted,textAlign:"center"}}>Sem garçom</div>
        </div>
      </div>}

      {/* MODAL FECHAMENTO CAIXA */}
      {showFechamento&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:960,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(6px)"}} onClick={()=>setShowFechamento(false)}>
        <div style={{background:DC.card,borderRadius:20,padding:32,width:460,border:`1px solid ${DC.border}`,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:20,fontWeight:900,marginBottom:4}}>🔒 Fechamento de Caixa</div>
          <div style={{fontSize:12,color:DC.textMuted,marginBottom:20}}>Operador: <b>{logado?.nome}</b> · Aberto: {fmtHora(logado?.inicio)}</div>
          
          <div style={{background:DC.bgSoft,borderRadius:12,padding:16,border:`1px solid ${DC.border}`,marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:10}}>Resumo da Sessão</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
              <div>Vendas:</div><div style={{textAlign:"right",fontWeight:700}}>{vendasSessao.length}</div>
              <div>Faturamento:</div><div style={{textAlign:"right",fontWeight:800,color:DC.green,fontFamily:mono}}>{fmt(fatSessao)}</div>
              <div style={{gridColumn:"1/-1",borderTop:`1px solid ${DC.border}`,margin:"4px 0"}}></div>
              <div>💵 Dinheiro:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(dinheiroSessao)}</div>
              <div>📱 PIX:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(pixSessao)}</div>
              <div>💳 Crédito:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(creditoSessao)}</div>
              <div>💳 Débito:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(debitoSessao)}</div>
              <div>🪙 Cashback:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(cashbackSessao)}</div>
            </div>
          </div>

          <div style={{background:DC.bgSoft,borderRadius:12,padding:16,border:`1px solid ${DC.border}`,marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>Conferência de Dinheiro</span>
              {movsSessao.length>0&&<span onClick={()=>setShowHistMov(true)} style={{fontSize:10,color:DC.blue,cursor:"pointer",fontWeight:600}}>Ver histórico ({movsSessao.length})</span>}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
              <div>Fundo inicial:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(fundoVal)}</div>
              <div>+ Vendas dinheiro:</div><div style={{textAlign:"right",fontFamily:mono}}>{fmt(dinheiroSessao)}</div>
              {totalSuprimentos>0&&<>
                <div style={{color:DC.blue}}>+ Suprimentos:</div><div style={{textAlign:"right",fontFamily:mono,color:DC.blue}}>{fmt(totalSuprimentos)}</div>
              </>}
              {totalSangrias>0&&<>
                <div style={{color:DC.orange}}>− Sangrias:</div><div style={{textAlign:"right",fontFamily:mono,color:DC.orange}}>−{fmt(totalSangrias)}</div>
              </>}
              <div style={{gridColumn:"1/-1",borderTop:`1px solid ${DC.border}`,margin:"4px 0"}}></div>
              <div style={{fontWeight:800}}>= Esperado:</div><div style={{textAlign:"right",fontWeight:800,color:DC.green,fontFamily:mono}}>{fmt(dinheiroEsperado)}</div>
            </div>
            <div style={{marginTop:12}}>
              <label style={{fontSize:11,color:DC.textMuted,display:"block",marginBottom:4}}>Dinheiro contado na gaveta:</label>
              <input value={fechDinheiro} onChange={e=>setFechDinheiro(e.target.value.replace(/[^\d.,]/g,""))} style={{...sInput,width:"100%",fontSize:20,fontWeight:900,textAlign:"center",fontFamily:mono,color:DC.green}} placeholder={dinheiroEsperado.toFixed(2)} autoFocus/>
            </div>
            {fechDinheiro&&(()=>{const d=pv(fechDinheiro)-dinheiroEsperado;return(
              <div style={{marginTop:8,padding:"8px 12px",borderRadius:8,background:Math.abs(d)<0.01?DC.greenSoft:d>0?DC.blueSoft:DC.accentSoft,display:"flex",justifyContent:"space-between"}}>
                <span style={{fontSize:12,fontWeight:700,color:Math.abs(d)<0.01?DC.green:d>0?DC.blue:DC.accent}}>{Math.abs(d)<0.01?"✅ Caixa conferido":d>0?"📈 Sobra":"📉 Falta"}</span>
                <span style={{fontSize:14,fontWeight:900,fontFamily:mono,color:Math.abs(d)<0.01?DC.green:d>0?DC.blue:DC.accent}}>{fmt(Math.abs(d))}</span>
              </div>
            );})()}
          </div>

          {/* Senha do operador para confirmar fechamento */}
          {logado?.id&&logado.id!==0&&<div style={{background:DC.bgSoft,borderRadius:12,padding:16,border:`1px solid ${DC.border}`,marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:700,marginBottom:10}}>🔐 Confirme sua senha para fechar</div>
            <input type="password" value={fechSenha} onChange={e=>{setFechSenha(e.target.value);setFechSenhaErro("");}}
              onKeyDown={e=>{if(e.key==="Enter")fecharCaixa();}}
              style={{...sInput,width:"100%",fontSize:18,fontWeight:800,textAlign:"center",letterSpacing:6}} placeholder="••••"/>
            {fechSenhaErro&&<div style={{marginTop:8,padding:"8px 12px",borderRadius:8,background:DC.accentSoft,color:DC.accent,fontSize:12,fontWeight:600,textAlign:"center"}}>{fechSenhaErro}</div>}
          </div>}

          <div style={{display:"flex",gap:10}}>
            <button onClick={imprimirRelatorio} style={{...sBtn(DC.card,DC.textSoft),flex:1,border:`1px solid ${DC.border}`,padding:14,fontSize:13}}>🖨 Imprimir</button>
            <button onClick={fecharCaixa} disabled={fechLoading} style={{...sBtn(DC.accent,"#fff"),flex:1,padding:14,fontSize:13,opacity:fechLoading?.6:1}}>{fechLoading?"Verificando...":"🔒 Fechar Caixa"}</button>
          </div>
          <div onClick={()=>setShowFechamento(false)} style={{textAlign:"center",padding:8,marginTop:8,fontSize:11,color:DC.textMuted,cursor:"pointer"}}>Cancelar</div>
        </div>
      </div>}

      {/* MODAL CONFIG */}
      {showConfig&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:900,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(4px)"}} onClick={()=>setShowConfig(false)}>
        <div style={{background:DC.card,borderRadius:16,width:520,maxHeight:"80vh",border:`1px solid ${DC.border}`,boxShadow:`0 20px 60px rgba(0,0,0,.5)`,display:"flex",flexDirection:"column",overflow:"hidden"}} onClick={e=>e.stopPropagation()}>
          <div style={{padding:"16px 24px",borderBottom:`1px solid ${DC.border}`,display:"flex",justifyContent:"space-between"}}><div style={{fontSize:18,fontWeight:800}}>⚙ Configurações PDV</div><div onClick={()=>setShowConfig(false)} style={{cursor:"pointer",fontSize:18,color:DC.textMuted}}>✕</div></div>
          <div style={{display:"flex",borderBottom:`1px solid ${DC.border}`}}>
            {[{k:"geral",l:"⚙ Geral"},{k:"caixas",l:"💰 Caixas"},{k:"garcons",l:"👤 Garçons"}].map(t=><div key={t.k} onClick={()=>{setConfigAba(t.k);setFormUsuario({id:null,nome:"",senha:"",tipo:t.k==="garcons"?"garcom":"caixa"});}} style={{flex:1,padding:10,textAlign:"center",fontSize:13,fontWeight:configAba===t.k?700:500,color:configAba===t.k?DC.text:DC.textMuted,borderBottom:configAba===t.k?`2px solid ${DC.green}`:"2px solid transparent",cursor:"pointer"}}>{t.l}</div>)}
          </div>
          <div style={{padding:24,overflowY:"auto",flex:1}}>
            {configAba==="geral"&&<>
              <div style={{padding:12,background:DC.bgSoft,borderRadius:10,border:`1px solid ${DC.border}`,marginBottom:16}}>
                <div style={{fontSize:13,fontWeight:800,marginBottom:10,color:DC.text}}>📋 Funcionalidades da Loja</div>
                <div style={{fontSize:11,color:DC.textMuted,marginBottom:12}}>Defina o que essa loja usa. Vai refletir no PDV e no app do garçom.</div>
                {[
                  {k:"mesa",l:"🍽 Mesa",d:"Mesas numeradas (cliente sentado)",val:usaMesa,set:setUsaMesa},
                  {k:"carro",l:"🚗 Carro",d:"Drive-thru / atendimento veicular",val:usaCarro,set:setUsaCarro},
                  {k:"comanda",l:"📋 Comanda",d:"Comandas avulsas no balcão",val:usaComanda,set:setUsaComanda}
                ].map(t=>(
                  <div key={t.k} onClick={()=>{
                    const novo=!t.val;t.set(novo);
                    localStorage.setItem(LK("pdv_usa_"+t.k),novo?"1":"0");
                    fetch("https://mixupbr.com.br/api/pdv_comandas/",{
                      method:"POST",headers:{"Content-Type":"application/json"},
                      body:JSON.stringify({
                        acao:"salvar_config_loja",
                        loja_id:lojaId||1,
                        usa_mesa:t.k==="mesa"?(novo?1:0):(usaMesa?1:0),
                        usa_carro:t.k==="carro"?(novo?1:0):(usaCarro?1:0),
                        usa_comanda:t.k==="comanda"?(novo?1:0):(usaComanda?1:0)
                      })
                    }).then(r=>r.json()).then(d=>{
                      if(d.ok)notify("Configuração salva");else notify("Erro: "+(d.erro||""),false);
                    }).catch(()=>notify("Erro de conexão",false));
                    if(abaAtiva===t.k+"s"&&!novo)setAbaAtiva("vendas");
                  }} style={{display:"flex",alignItems:"center",gap:10,padding:10,marginBottom:6,borderRadius:8,border:`2px solid ${t.val?DC.green:DC.border}`,background:t.val?`${DC.green}15`:DC.card,cursor:"pointer"}}>
                    <div style={{width:22,height:22,borderRadius:6,background:t.val?DC.green:"transparent",border:`2px solid ${t.val?DC.green:DC.border}`,display:"flex",alignItems:"center",justifyContent:"center"}}>{t.val&&<span style={{color:"#fff",fontWeight:900,fontSize:12}}>✓</span>}</div>
                    <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700,color:DC.text}}>{t.l}</div><div style={{fontSize:10,color:DC.textMuted,marginTop:2}}>{t.d}</div></div>
                  </div>
                ))}
              </div>
              {usaMesa&&<div style={{marginBottom:16}}><label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Quantidade de Mesas</label><input value={totalMesas} onChange={e=>{const v=parseInt(e.target.value)||1;setTotalMesas(v);localStorage.setItem(LK("pdv_total_mesas"),String(v));}} type="number" min="1" max="50" style={{...sInput,width:"100%",fontSize:16,fontWeight:800,textAlign:"center"}}/></div>}
              {usaCarro&&<div style={{marginBottom:16}}><label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Quantidade de Carros</label><input value={totalCarros} onChange={e=>{const v=parseInt(e.target.value)||1;setTotalCarros(v);localStorage.setItem(LK("pdv_total_carros"),String(v));}} type="number" min="1" max="30" style={{...sInput,width:"100%",fontSize:16,fontWeight:800,textAlign:"center"}}/></div>}
              {usaComanda&&<div style={{marginBottom:16}}><label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Quantidade de Comandas</label><input value={totalComandas} onChange={e=>{const v=parseInt(e.target.value)||1;setTotalComandas(v);localStorage.setItem(LK("pdv_total_comandas"),String(v));}} type="number" min="1" max="100" style={{...sInput,width:"100%",fontSize:16,fontWeight:800,textAlign:"center"}}/></div>}
              <div style={{marginBottom:16}}><label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Taxa PYG</label><input value={cambio.taxaPyg} onChange={e=>{const v=e.target.value;setCambio(c=>({...c,taxaPyg:v}));localStorage.setItem(LK("pdv_taxas"),JSON.stringify({pyg:v,usd:cambio.taxaUsd}));}} style={{...sInput,width:"100%",fontSize:14,fontWeight:700,textAlign:"center"}} placeholder="1240"/></div>
              <div style={{marginBottom:16}}><label style={{fontSize:12,color:DC.textMuted,fontWeight:600,display:"block",marginBottom:6}}>Taxa USD</label><input value={cambio.taxaUsd} onChange={e=>{const v=e.target.value;setCambio(c=>({...c,taxaUsd:v}));localStorage.setItem(LK("pdv_taxas"),JSON.stringify({pyg:cambio.taxaPyg,usd:v}));}} style={{...sInput,width:"100%",fontSize:14,fontWeight:700,textAlign:"center"}} placeholder="5.40"/></div>
            </>}
            {(configAba==="garcons"||configAba==="caixas")&&(()=>{
              const tp=configAba==="garcons"?"garcom":"caixa";const lista=usuarios.filter(u=>u.tipo===tp);const lb=configAba==="garcons"?"Garçom":"Caixa";
              return<>
                <div style={{background:DC.bgSoft,borderRadius:12,padding:16,border:`1px solid ${DC.border}`,marginBottom:16}}>
                  <div style={{fontSize:13,fontWeight:700,marginBottom:12}}>{formUsuario.id?`Editar ${lb}`:`Novo ${lb}`}</div>
                  <div style={{display:"flex",gap:8,marginBottom:8}}>
                    <div style={{flex:1}}><div style={{fontSize:10,color:DC.textMuted,marginBottom:3}}>Nome *</div><input value={formUsuario.nome} onChange={e=>setFormUsuario(f=>({...f,nome:e.target.value}))} style={{...sInput,width:"100%"}} placeholder={`Nome`}/></div>
                    <div style={{flex:1}}><div style={{fontSize:10,color:DC.textMuted,marginBottom:3}}>Senha {formUsuario.id?"(vazio=manter)":"*"}</div><input type="password" value={formUsuario.senha} onChange={e=>setFormUsuario(f=>({...f,senha:e.target.value}))} style={{...sInput,width:"100%"}} placeholder="••••"/></div>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={salvarUsuario} disabled={usuarioLoading} style={{...sBtn(DC.green,"#fff"),flex:1,opacity:usuarioLoading?0.6:1}}>{formUsuario.id?"Salvar":"Cadastrar"}</button>
                    {formUsuario.id&&<button onClick={()=>setFormUsuario({id:null,nome:"",senha:"",tipo:tp})} style={{...sBtn(DC.card,DC.textMuted),border:`1px solid ${DC.border}`}}>Cancelar</button>}
                  </div>
                </div>
                {lista.length===0&&<div style={{textAlign:"center",padding:20,color:DC.textMuted,fontSize:12}}>Nenhum {lb.toLowerCase()} cadastrado</div>}
                {lista.map(u=><div key={u.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",borderRadius:10,border:`1px solid ${DC.border}`,marginBottom:6,background:DC.bgSoft}}>
                  <div style={{width:36,height:36,borderRadius:8,background:`${DC.green}15`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:900,color:DC.green}}>{(u.nome||"?")[0].toUpperCase()}</div>
                  <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700}}>{u.nome}</div><div style={{fontSize:10,color:DC.textMuted}}>ID:{u.id}</div></div>
                  <div onClick={()=>setFormUsuario({id:u.id,nome:u.nome,senha:"",tipo:u.tipo})} style={{cursor:"pointer",fontSize:11,color:DC.blue,fontWeight:600,padding:"4px 10px",borderRadius:6,border:`1px solid ${DC.blue}30`}}>Editar</div>
                  <div onClick={()=>excluirUsuario(u.id)} style={{cursor:"pointer",fontSize:11,color:DC.accent,fontWeight:600,padding:"4px 10px",borderRadius:6,border:`1px solid ${DC.accent}30`}}>Excluir</div>
                </div>)}
              </>;
            })()}
          </div>
        </div>
      </div>}
    </div>
  );
}

/* ═══ SUB-COMPONENTES (mesmos de antes, compactos) ═══ */

function CatBtn({ativa,onClick,children}){return<div onClick={onClick} style={{flex:"0 0 auto",padding:"8px 16px",fontSize:12,fontWeight:ativa?700:500,color:ativa?DC.accent:DC.textMuted,borderBottom:ativa?`2px solid ${DC.accent}`:"2px solid transparent",cursor:"pointer",whiteSpace:"nowrap"}}>{children}</div>;}

function ProdGrid({produtos,prodsFilt,cats,catAtiva,setCatAtiva,busca,setBusca,prodSel,setProdSel,add,buscaRef,header,hover}){
  const hc=hover||DC.green;
  return<div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
    <div style={{padding:"8px 14px",borderBottom:`1px solid ${DC.border}`,display:"flex",alignItems:"center",gap:10,background:DC.bgSoft}}>
      {header||null}
      <div style={{marginLeft:header?"auto":"0",flex:header?undefined:1,maxWidth:header?280:360}}><input ref={buscaRef} value={busca} onChange={e=>{setBusca(e.target.value);setProdSel(0);}} placeholder="🔍 Buscar..." style={{...sInput,width:"100%",fontSize:13}}/></div>
      {!header&&<div style={{display:"flex",gap:0,flex:1,overflowX:"auto"}}><CatBtn ativa={catAtiva==="todos"} onClick={()=>setCatAtiva("todos")}>Todos</CatBtn>{cats.map(c=><CatBtn key={c} ativa={catAtiva===c} onClick={()=>setCatAtiva(c)}>{c}</CatBtn>)}</div>}
    </div>
    {header&&<div style={{display:"flex",borderBottom:`1px solid ${DC.border}`,background:DC.bgSoft,overflowX:"auto"}}><CatBtn ativa={catAtiva==="todos"} onClick={()=>setCatAtiva("todos")}>Todos</CatBtn>{cats.map(c=><CatBtn key={c} ativa={catAtiva===c} onClick={()=>setCatAtiva(c)}>{c}</CatBtn>)}</div>}
    <div style={{flex:1,overflowY:"auto",padding:10,background:DC.bg}}>
      {produtos.length===0?<div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",color:DC.textMuted}}>Carregando...</div>:
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:8}}>
        {prodsFilt.map((p,idx)=>{const sel=idx===prodSel&&busca;const preco=parseFloat(p.preco||p.valor||0);const img=p.imagem_url||p.imagem||p.foto||p.image||null;
          return<div key={p.id} onClick={()=>add(p)} style={{background:DC.card,borderRadius:10,overflow:"hidden",cursor:"pointer",border:sel?`2px solid ${hc}`:`1px solid ${DC.border}`,transition:"all .12s",display:"flex",flexDirection:"column"}} onMouseOver={e=>{e.currentTarget.style.borderColor=hc;e.currentTarget.style.transform="translateY(-2px)";}} onMouseOut={e=>{if(!sel){e.currentTarget.style.borderColor=DC.border;e.currentTarget.style.transform="none";}}}>
            <div style={{height:90,background:DC.bgSoft,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>{img?<img src={img} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<span style={{fontSize:36,opacity:.3}}>🍔</span>}</div>
            <div style={{padding:"8px 10px"}}><div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginBottom:4}}>{p.nome}</div><div style={{fontSize:15,fontWeight:800,color:DC.green,fontFamily:mono}}>{fmt(preco)}</div></div>
          </div>;
        })}
      </div>}
      {prodsFilt.length===0&&produtos.length>0&&<div style={{textAlign:"center",padding:40,color:DC.textMuted}}>Nenhum produto</div>}
    </div>
  </div>;
}

function Ticket({comanda,setComanda,itemSel,setItemSel,altQtd,rem,ativoTipo,ativoNum,garcom,itensAtivos,subtotal,total,totalGs,desconto,setDesconto,descontoTipo,setDescontoTipo,descontoVal,showPag,setShowPag,modoPag,setModoPag,pagForma,setPagForma,pagRec,setPagRec,pagRef,pag,setPag,tpm,dif,loading,fin,notify}){
  return<div style={{width:360,display:"flex",flexDirection:"column",borderLeft:`1px solid ${DC.border}`,background:DC.bgSoft,flexShrink:0}}>
    <div style={{padding:"12px 16px",borderBottom:`1px solid ${DC.border}`,display:"flex",justifyContent:"space-between"}}><div><div style={{fontSize:14,fontWeight:800}}>{ativoTipo==="venda"?"🛒 Venda Balcão":ativoTipo==="carro"?`🚗 Carro ${ativoNum}`:ativoTipo==="comanda"?`📋 Comanda ${ativoNum}`:`🍽 Mesa ${ativoNum}`}</div><div style={{fontSize:10,color:DC.textMuted}}>{itensAtivos.length} itens{garcom?` · 👤 ${garcom.nome||garcom}`:""}</div></div>{comanda.length>0&&<div onClick={()=>{setComanda([]);notify("Limpo");}} style={{fontSize:11,color:DC.accent,cursor:"pointer",fontWeight:600,padding:"4px 10px",borderRadius:6,border:`1px solid ${DC.accent}40`}}>Limpar</div>}</div>
    {showPag?<div onClick={()=>setShowPag(false)} style={{padding:"10px 14px",borderBottom:`1px solid ${DC.border}`,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",background:DC.card}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>🧾</span><span style={{fontSize:12,fontWeight:700,color:DC.text}}>{itensAtivos.length} itens</span></div>
      <span style={{fontSize:11,fontWeight:600,color:DC.blue,padding:"3px 10px",borderRadius:6,border:`1px solid ${DC.blue}40`,background:`${DC.blue}10`}}>Ver Itens</span>
    </div>:<div style={{flex:1,overflowY:"auto",padding:"4px 0"}}>
      {comanda.length===0&&<div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",gap:8,opacity:.4}}><span style={{fontSize:40}}>🧾</span><span style={{fontSize:12,color:DC.textMuted}}>Selecione produtos</span></div>}
      {comanda.map(it=><div key={it.uid} onClick={()=>setItemSel(it.uid===itemSel?null:it.uid)} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 14px",borderBottom:`1px solid ${DC.border}20`,opacity:it.cancelado?.25:1,background:itemSel===it.uid?`${DC.blue}12`:"transparent",cursor:"pointer"}}>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>{!it.cancelado&&<div onClick={e=>{e.stopPropagation();altQtd(it.uid,1);}} style={{width:20,height:16,borderRadius:3,background:DC.greenSoft,color:DC.green,cursor:"pointer",fontSize:11,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center"}}>+</div>}<span style={{fontSize:14,fontWeight:900,minWidth:18,textAlign:"center"}}>{it.quantidade}</span>{!it.cancelado&&<div onClick={e=>{e.stopPropagation();altQtd(it.uid,-1);}} style={{width:20,height:16,borderRadius:3,background:DC.accentSoft,color:DC.accent,cursor:"pointer",fontSize:11,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center"}}>−</div>}</div>
        <div style={{flex:1,minWidth:0}}><div style={{fontSize:12,fontWeight:600,textDecoration:it.cancelado?"line-through":"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{it.nome}</div>{it.quantidade>1&&<div style={{fontSize:10,color:DC.textMuted}}>{fmt(it.preco_unitario)}×{it.quantidade}</div>}</div>
        <div style={{textAlign:"right",flexShrink:0}}><div style={{fontSize:13,fontWeight:800,color:it.cancelado?DC.accent:DC.green,fontFamily:mono}}>{fmt(it.preco_total)}</div>{!it.cancelado&&<div onClick={e=>{e.stopPropagation();rem(it.uid);}} style={{fontSize:9,color:DC.accent,cursor:"pointer",fontWeight:600}}>✕</div>}</div>
      </div>)}
    </div>}
    <div style={{borderTop:`2px solid ${DC.border}`,padding:"10px 16px",background:DC.card}}>
      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}><span style={{fontSize:10,color:DC.textMuted}}>Desc:</span><input value={desconto} onChange={e=>setDesconto(e.target.value.replace(/[^\d.,]/g,""))} placeholder="0" style={{...sInput,width:70,fontSize:12,fontWeight:700,textAlign:"right",padding:"4px 8px",fontFamily:mono}}/><div onClick={()=>setDescontoTipo(descontoTipo==="real"?"pct":"real")} style={{fontSize:10,fontWeight:700,color:DC.purple,cursor:"pointer",padding:"3px 8px",borderRadius:4,border:`1px solid ${DC.purple}30`,background:DC.purpleSoft}}>{descontoTipo==="pct"?"%":"R$"}</div>{descontoVal>0&&<span style={{fontSize:11,fontWeight:700,color:DC.accent,marginLeft:"auto"}}>-{fmt(descontoVal)}</span>}</div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline"}}><span style={{fontSize:13,fontWeight:600,color:DC.textSoft}}>TOTAL</span><div style={{textAlign:"right"}}><div style={{fontSize:28,fontWeight:900,color:DC.green,fontFamily:mono,letterSpacing:-1}}>{fmt(total)}</div><div style={{fontSize:11,fontWeight:700,color:DC.purple}}>{totalGs}</div></div></div>
    </div>
    {!showPag?<div style={{padding:"10px 14px",borderTop:`1px solid ${DC.border}`}}><button onClick={()=>{if(itensAtivos.length===0){notify("Sem itens",false);return;}setShowPag(true);}} disabled={itensAtivos.length===0} style={{...sBtn(itensAtivos.length>0?DC.green:DC.border,itensAtivos.length>0?"#fff":DC.textMuted),width:"100%",padding:14,fontSize:15,borderRadius:10}}>F9 — Pagamento {itensAtivos.length>0?fmt(total):""}</button></div>
    :<div style={{borderTop:`1px solid ${DC.border}`,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"10px 14px",overflowY:"auto",maxHeight:340}}>
      <div style={{fontSize:10,color:DC.textMuted,textAlign:"center",marginBottom:6}}>1-6 forma · Esc voltar</div>
      {modoPag==="rapido"?<>
        <div style={{display:"flex",flexDirection:"column",gap:3}}>{FORMAS.map(fp=>{const sel=pagForma===fp.k;return<div key={fp.k} onClick={()=>{setPagForma(fp.k);if(fp.k==="dinheiro"){setPagRec("");setTimeout(()=>pagRef.current?.focus(),50);}else{var _r=Math.floor(total);var _c=String(Math.round((total-_r)*100)).padStart(2,"0");setPagRec(_r.toLocaleString("pt-BR")+","+_c);}}} style={{display:"flex",alignItems:"center",gap:8,padding:sel?"10px 12px":"8px 12px",borderRadius:8,border:sel?`2px solid ${DC.green}`:`1px solid ${DC.border}`,background:sel?DC.greenSoft:"transparent",cursor:"pointer"}}><span style={{width:22,height:22,borderRadius:5,background:sel?DC.green:DC.card,color:sel?"#fff":DC.textMuted,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:900,border:`1px solid ${sel?DC.green:DC.border}`}}>{fp.n}</span><span style={{fontSize:14}}>{fp.ico}</span><span style={{flex:1,fontSize:12,fontWeight:sel?800:600,color:sel?DC.text:DC.textMuted}}>{fp.l}</span><span style={{fontSize:11,fontWeight:sel?800:600,color:sel?DC.green:DC.textMuted,fontFamily:mono}}>{fmt(total)}</span></div>;})}
        <div onClick={()=>{setModoPag("misto");setPagForma(null);}} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",borderRadius:8,border:`1px solid ${DC.purple}40`,background:"transparent",cursor:"pointer"}}><span style={{width:22,height:22,borderRadius:5,background:DC.card,color:DC.purple,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:900,border:`1px solid ${DC.purple}40`}}>6</span><span style={{fontSize:14}}>🔀</span><span style={{flex:1,fontSize:12,fontWeight:600,color:DC.textMuted}}>Misto</span><span style={{fontSize:10,fontWeight:700,color:DC.purple,fontFamily:mono}}>combinar</span></div>
        </div>
        {pagForma==="dinheiro"&&<div style={{marginTop:8}}><input ref={pagRef} value={pagRec} onChange={e=>{var raw=e.target.value.replace(/[^\d]/g,"");if(!raw){setPagRec("");return;}var num=parseInt(raw,10);var reais=Math.floor(num/100);var cents=String(num%100).padStart(2,"0");setPagRec(reais.toLocaleString("pt-BR")+","+cents);}} onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();fin();}}} placeholder="0,00" style={{...sInput,width:"100%",fontSize:22,fontWeight:900,textAlign:"center",color:DC.green,fontFamily:mono,padding:"10px",borderColor:DC.green}} inputMode="numeric" autoFocus/><div style={{display:"flex",gap:4,marginTop:4}}>{[total,50,100,200].map(v=><div key={v} onClick={()=>{var r=Math.floor(v);var c=String(Math.round((v-r)*100)).padStart(2,"0");setPagRec(r.toLocaleString("pt-BR")+","+c);}} style={{flex:1,padding:6,borderRadius:6,border:`1px solid ${DC.border}`,textAlign:"center",fontSize:11,color:DC.textMuted,cursor:"pointer",background:DC.card}}>{v===total?"Exato":"R$ "+v}</div>)}</div>{pv(pagRec)>0&&<div style={{marginTop:4,padding:"8px 12px",borderRadius:8,background:pv(pagRec)>=total?DC.green:DC.accent,display:"flex",justifyContent:"space-between"}}><span style={{fontSize:12,fontWeight:700,color:"#fff"}}>{pv(pagRec)>=total?"Troco":"Falta"}</span><span style={{fontSize:18,fontWeight:900,color:"#fff",fontFamily:mono}}>{fmt(Math.abs(pv(pagRec)-total))}</span></div>}</div>}
      </>:<div>
        <div style={{fontSize:12,fontWeight:800,marginBottom:6}}>Misto</div>
        {FORMAS.map(fp=><div key={fp.k} style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}><span style={{fontSize:11,fontWeight:700,color:DC.textMuted,minWidth:60}}>{fp.ico} {fp.l}</span><input value={pag[fp.k]} onChange={e=>{var raw=e.target.value.replace(/[^\d]/g,"");if(!raw){setPag(p=>({...p,[fp.k]:""}));return;}var num=parseInt(raw,10);var reais=Math.floor(num/100);var cents=String(num%100).padStart(2,"0");var formatted=reais.toLocaleString("pt-BR")+","+cents;setPag(p=>({...p,[fp.k]:formatted}));}} onFocus={e=>e.target.select()} placeholder="0,00" style={{...sInput,flex:1,textAlign:"right",fontSize:13,fontWeight:700,fontFamily:mono,color:pv(pag[fp.k])>0?DC.green:DC.text,borderColor:pv(pag[fp.k])>0?DC.green:DC.border}} inputMode="numeric"/></div>)}
        <div style={{marginTop:4,padding:"6px 10px",borderRadius:6,background:dif<-.01?DC.accent:dif>.01?DC.green:DC.card,display:"flex",justifyContent:"space-between"}}><span style={{fontSize:11,fontWeight:700,color:Math.abs(dif)>.01?"#fff":DC.textMuted}}>{dif<-.01?"Falta":dif>.01?"Troco":"OK"}</span><span style={{fontSize:15,fontWeight:900,color:Math.abs(dif)>.01?"#fff":DC.textMuted,fontFamily:mono}}>{fmt(Math.abs(dif))}</span></div>
        <div onClick={()=>{setModoPag("rapido");setPagForma(null);}} style={{textAlign:"center",padding:4,fontSize:10,color:DC.textMuted,cursor:"pointer",marginTop:4}}>← Rápido</div>
      </div>}
      </div>
      <div style={{padding:"10px 14px",borderTop:`1px solid ${DC.border}`,background:DC.bgSoft}}>
      <button onClick={fin} disabled={loading||(modoPag==="rapido"&&!pagForma)||(modoPag==="misto"&&dif<-.01)} style={{...sBtn((modoPag==="rapido"&&!pagForma)||(modoPag==="misto"&&dif<-.01)?DC.border:DC.green,(modoPag==="rapido"&&!pagForma)||(modoPag==="misto"&&dif<-.01)?DC.textMuted:"#fff"),width:"100%",padding:14,fontSize:15,borderRadius:10,opacity:loading?.6:1}}>{loading?"...":"F9 — Finalizar "+fmt(total)}</button>
      </div>
    </div>}
  </div>;
}

function IcoMesa({size=30,cor="#fff"}){
  return<svg width={size} height={size} viewBox="0 0 64 64" fill={cor} xmlns="http://www.w3.org/2000/svg">
    {/* 4 cadeiras nos cantos */}
    <rect x="8" y="8" width="14" height="14" rx="3"/>
    <rect x="42" y="8" width="14" height="14" rx="3"/>
    <rect x="8" y="42" width="14" height="14" rx="3"/>
    <rect x="42" y="42" width="14" height="14" rx="3"/>
    {/* Mesa central */}
    <circle cx="32" cy="32" r="14"/>
  </svg>;
}

function IcoComanda({size=30,cor="#fff"}){
  return<svg width={size} height={size} viewBox="0 0 64 64" fill={cor} xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="12" width="40" height="44" rx="4"/>
    <rect x="24" y="6" width="16" height="10" rx="2"/>
    <circle cx="32" cy="4" r="2.5"/>
    <rect x="18" y="24" width="28" height="3" fill="rgba(0,0,0,0.45)"/>
    <rect x="18" y="32" width="28" height="3" fill="rgba(0,0,0,0.45)"/>
    <rect x="18" y="40" width="28" height="3" fill="rgba(0,0,0,0.45)"/>
    <rect x="18" y="48" width="20" height="3" fill="rgba(0,0,0,0.45)"/>
  </svg>;
}

function IcoCarro({size=30,cor="#fff"}){
  return<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={cor} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
    {/* Teto + para-brisa */}
    <path d="M 14 28 L 18 16 L 46 16 L 50 28"/>
    {/* Corpo do carro */}
    <path d="M 8 30 L 14 28 L 50 28 L 56 30 L 56 44 L 50 44 L 50 48 L 14 48 L 14 44 L 8 44 Z"/>
    {/* Faróis */}
    <circle cx="14" cy="36" r="2.2" fill={cor}/>
    <circle cx="50" cy="36" r="2.2" fill={cor}/>
    {/* Grade central */}
    <line x1="22" y1="40" x2="42" y2="40"/>
  </svg>;
}

function MesaGrid({tipo,label,img,cor,total_,selNum,itemSt,itemTot,itemTmp,itemQtd,abrir,labels,getCliente,onAbrirLabels}){
  function estadoCor(tmpStr, ocupada){
    if(!ocupada) return {cor:DC.green, corTempo:DC.green, corBorda:null, critico:false, livre:true};
    let mins = 0;
    if(tmpStr){
      const mHora = tmpStr.match(/(\d+)h(?:(\d+)m)?/);
      const mMin = tmpStr.match(/^(\d+)min/);
      if(mHora) mins = parseInt(mHora[1])*60 + parseInt(mHora[2]||0);
      else if(mMin) mins = parseInt(mMin[1]);
    }
    if(mins < 15) return {cor:DC.blue, corTempo:DC.textSoft, corBorda:null, critico:false, livre:false};
    if(mins < 60) return {cor:DC.orange, corTempo:DC.orange, corBorda:null, critico:false, livre:false};
    return {cor:DC.accent, corTempo:DC.accent, corBorda:DC.accent, critico:true, livre:false};
  }

  function renderIcone(t, size, corIcone){
    if(t==="mesa") return <IcoMesa size={size} cor={corIcone||"#fff"}/>;
    if(t==="carro") return <IcoCarro size={size} cor={corIcone||"#fff"}/>;
    if(t==="comanda") return <IcoComanda size={size} cor={corIcone||"#fff"}/>;
    return null;
  }

  function nomeExibicao(n){
    const lblObj = (labels && labels[tipo]) || {};
    const apelido = lblObj[String(n)] || lblObj[n];
    return apelido || `${label} ${n}`;
  }

  let livres=0, ocupadas=0, totalGeral=0;
  for(let n=1; n<=total_; n++){
    const st=itemSt(tipo,n);
    if(st==="livre") livres++;
    else { ocupadas++; totalGeral += itemTot(tipo,n); }
  }
  const labelOcup = tipo==="comanda" ? "Abertas" : tipo==="carro" ? "Ocupados" : "Ocupadas";

  return<div style={{flex:1,display:"flex",flexDirection:"column"}}>
    <div style={{padding:"12px 20px",borderBottom:`1px solid ${DC.border}`,display:"flex",alignItems:"center",gap:12,background:DC.bgSoft}}>
      <div style={{width:30,height:30,borderRadius:"50%",background:cor,display:"flex",alignItems:"center",justifyContent:"center"}}>
        {renderIcone(tipo, 18)}
      </div>
      <span style={{fontSize:18,fontWeight:800,color:cor}}>{label}s</span>
      <span style={{fontSize:11,color:DC.textMuted,flex:1}}>Setas · Enter · Esc</span>
      <button onClick={()=>onAbrirLabels(tipo)} title={`Renomear ${label.toLowerCase()}s`} style={{...sBtn(DC.card,DC.textSoft),border:`1px solid ${DC.border}`,padding:"6px 12px",fontSize:12,display:"flex",alignItems:"center",gap:6}}>
        ⚙ Editar nomes
      </button>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,padding:"14px 20px 0",background:DC.bg}}>
      <div style={{background:DC.card,borderRadius:10,padding:"10px 14px",borderLeft:`4px solid ${DC.green}`}}>
        <div style={{fontSize:11,color:DC.textMuted,marginBottom:4}}>Livres</div>
        <div style={{fontSize:22,fontWeight:800,color:DC.text}}>{livres}</div>
      </div>
      <div style={{background:DC.card,borderRadius:10,padding:"10px 14px",borderLeft:`4px solid ${DC.orange}`}}>
        <div style={{fontSize:11,color:DC.textMuted,marginBottom:4}}>{labelOcup}</div>
        <div style={{fontSize:22,fontWeight:800,color:DC.text}}>{ocupadas}</div>
      </div>
      <div style={{background:DC.card,borderRadius:10,padding:"10px 14px",borderLeft:`4px solid ${cor}`}}>
        <div style={{fontSize:11,color:DC.textMuted,marginBottom:4}}>Total</div>
        <div style={{fontSize:16,fontWeight:800,color:DC.text,fontFamily:mono}}>{fmt(totalGeral)}</div>
      </div>
    </div>

    <div style={{flex:1,overflowY:"auto",padding:20,background:DC.bg}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:14}}>
        {Array.from({length:total_},(_,i)=>i+1).map(n=>{
          const st=itemSt(tipo,n);
          const tot=itemTot(tipo,n);
          const tmp=itemTmp(tipo,n);
          const qtd=itemQtd(tipo,n);
          const sel=selNum===n;
          const ocupada=st!=="livre";
          const e=estadoCor(tmp, ocupada);
          const nomeMostrar = nomeExibicao(n);
          const cliente = ocupada && getCliente ? getCliente(tipo, n) : "";

          return<div key={n} onClick={()=>abrir(tipo,n)} style={{
            position:"relative",
            display:"flex",flexDirection:"column",alignItems:"center",
            background:DC.card,
            borderRadius:14,
            border:sel?`2px solid ${cor}`:(e.corBorda?`2px solid ${e.corBorda}`:`1px solid ${DC.border}`),
            padding:"16px 12px 14px",
            cursor:"pointer",
            transition:"all .15s",
            transform:sel?"scale(1.04)":"scale(1)",
            boxShadow:sel?`0 0 24px ${cor}50`:"none",
            minHeight:170,
          }}>
            <div style={{position:"absolute",top:8,left:12,fontSize:11,fontWeight:700,color:DC.textMuted,letterSpacing:0.3,maxWidth:"75%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
              {nomeMostrar}
            </div>
            {e.critico && <div style={{position:"absolute",top:6,right:12,fontSize:14,color:DC.accent}}>⏱</div>}

            <div style={{width:88,height:88,display:"flex",alignItems:"center",justifyContent:"center",marginTop:14,marginBottom:10,filter:`drop-shadow(0 4px 10px ${e.cor}55)`}}>
              {renderIcone(tipo, 80, e.cor)}
            </div>

            {ocupada ? (
              <div style={{fontSize:16,fontWeight:800,color:DC.text,fontFamily:mono,marginTop:2}}>{fmt(tot)}</div>
            ) : (
              <div style={{fontSize:13,fontWeight:700,color:DC.green,marginTop:6}}>Livre</div>
            )}

            {ocupada && cliente && (
              <div style={{fontSize:11,marginTop:2,color:DC.text,fontWeight:600,maxWidth:"100%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",padding:"0 4px"}}>
                👤 {cliente}
              </div>
            )}

            {ocupada && (
              <div style={{fontSize:11,marginTop:3,color:e.corTempo,fontWeight:e.critico||(e.cor===DC.orange)?700:400}}>
                {qtd} ite{qtd!==1?"ns":"m"} · {tmp}
              </div>
            )}
          </div>;
        })}
      </div>
    </div>
  </div>;
}

/* ═══ MODAL: Editar labels persistentes ═══ */
function ModalLabels({aberto, tipo, label, total_, labels, onClose, onSalvar}){
  const [valores, setValores] = useState({});
  useEffect(()=>{
    if(aberto){
      const tipoLbl = (labels && labels[tipo]) || {};
      const init = {};
      for(let n=1; n<=total_; n++) init[n] = tipoLbl[String(n)] || tipoLbl[n] || "";
      setValores(init);
    }
  },[aberto, tipo, total_, labels]);

  if(!aberto) return null;
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div onClick={(e)=>e.stopPropagation()} style={{background:DC.card,borderRadius:14,padding:24,width:"100%",maxWidth:500,maxHeight:"85vh",display:"flex",flexDirection:"column",border:`1px solid ${DC.border}`}}>
      <div style={{fontSize:18,fontWeight:800,color:DC.text,marginBottom:6}}>⚙ Renomear {label}s</div>
      <div style={{fontSize:12,color:DC.textMuted,marginBottom:16}}>Personalize o nome de cada {label.toLowerCase()}. Deixe em branco para usar o padrão "{label} N".</div>
      <div style={{flex:1,overflowY:"auto",display:"flex",flexDirection:"column",gap:8,paddingRight:6}}>
        {Array.from({length:total_},(_,i)=>i+1).map(n=>(
          <div key={n} style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{minWidth:38,fontSize:13,fontWeight:700,color:DC.textMuted,fontFamily:mono}}>#{n}</div>
            <input
              type="text"
              maxLength={60}
              placeholder={`${label} ${n}`}
              value={valores[n]||""}
              onChange={(ev)=>setValores({...valores,[n]:ev.target.value})}
              style={{...sInput,flex:1}}
            />
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:8,marginTop:16,paddingTop:16,borderTop:`1px solid ${DC.border}`}}>
        <button onClick={onClose} style={{...sBtn(DC.card,DC.textSoft),border:`1px solid ${DC.border}`,flex:1}}>Cancelar</button>
        <button onClick={()=>onSalvar(valores)} style={{...sBtn(DC.green,"#fff"),flex:2}}>💾 Salvar</button>
      </div>
    </div>
  </div>;
}

function CaixaTab({orders,cambio,cxFiltro,setCxFiltro,cxRelatorio,cxLoading,carregarRelatorio,usuarios,logado,vendasSessao,fatSessao,dinheiroSessao,pixSessao,creditoSessao,debitoSessao,cashbackSessao,fundoVal,dinheiroEsperado,imprimirRelatorio,reimprimirRecibo}){
  const hoje=new Date().toISOString().slice(0,10);
  const vh=(orders||[]).filter(o=>o.criado_em?.startsWith(hoje)&&o.status==="entregue");
  const fat=vh.reduce((s,o)=>s+valorReal(o),0);
  const relTot=cxRelatorio.reduce((s,o)=>s+valorReal(o),0);
  const relPf={};cxRelatorio.forEach(o=>{const f=o.forma_pagamento||"outro";relPf[f]=(relPf[f]||0)+valorReal(o);});
  const cx=usuarios.filter(u=>u.tipo==="caixa"||u.tipo==="admin");
  const gc=usuarios.filter(u=>u.tipo==="garcom");

  return<div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
    {/* Sessão atual */}
    <div style={{padding:"16px 20px",borderBottom:`1px solid ${DC.border}`,background:DC.bgSoft}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{fontSize:18,fontWeight:800}}>💰 Caixa — {logado?.nome}</div>
        <button onClick={imprimirRelatorio} style={{...sBtn(DC.card,DC.textSoft),border:`1px solid ${DC.border}`,padding:"8px 16px",fontSize:12}}>🖨 Imprimir Relatório</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:8}}>
        <KpiCard ico="🧾" lb="Vendas sessão" vl={vendasSessao.length} cor={DC.green}/>
        <KpiCard ico="💰" lb="Faturamento" vl={fmt(fatSessao)} sub={fmtGs(fatSessao,cambio.taxaPyg)} cor={DC.green}/>
        <KpiCard ico="💵" lb="Dinheiro" vl={fmt(dinheiroSessao)} cor={DC.blue}/>
        <KpiCard ico="📱" lb="PIX" vl={fmt(pixSessao)} cor={DC.blue}/>
        <KpiCard ico="💳" lb="Cartão" vl={fmt(creditoSessao+debitoSessao)} cor={DC.blue}/>
        <KpiCard ico="🪙" lb="Cashback" vl={fmt(cashbackSessao)} cor={DC.purple}/>
        <KpiCard ico="💰" lb="Fundo" vl={fmt(fundoVal)} cor={DC.yellow}/>
        <KpiCard ico="📊" lb="Gaveta esperada" vl={fmt(dinheiroEsperado)} cor={DC.green}/>
      </div>
    </div>
    {/* Filtros relatório */}
    <div style={{padding:"14px 20px",borderBottom:`2px solid ${DC.border}`,background:`linear-gradient(135deg, ${DC.bgSoft} 0%, ${DC.card} 100%)`}}>
      <div style={{fontSize:16,fontWeight:900,marginBottom:10,display:"flex",alignItems:"center",gap:8}}>📊 Relatório de Operações<span style={{fontSize:11,fontWeight:500,color:DC.textMuted,marginLeft:8}}>Filtre e reimprima recibos</span></div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,alignItems:"flex-end"}}>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>De</div><input type="date" value={cxFiltro.de} onChange={e=>setCxFiltro(f=>({...f,de:e.target.value}))} style={{...sInput,fontSize:12}}/></div>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>Até</div><input type="date" value={cxFiltro.ate} onChange={e=>setCxFiltro(f=>({...f,ate:e.target.value}))} style={{...sInput,fontSize:12}}/></div>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>Caixa</div><select value={cxFiltro.caixa} onChange={e=>setCxFiltro(f=>({...f,caixa:e.target.value}))} style={{...sInput,fontSize:12,minWidth:110}}><option value="">Todos</option>{cx.map(u=><option key={u.id} value={u.nome}>{u.nome}</option>)}</select></div>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>Garçom</div><select value={cxFiltro.garcom} onChange={e=>setCxFiltro(f=>({...f,garcom:e.target.value}))} style={{...sInput,fontSize:12,minWidth:110}}><option value="">Todos</option>{gc.map(u=><option key={u.id} value={u.nome}>{u.nome}</option>)}</select></div>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>Pgto</div><select value={cxFiltro.forma} onChange={e=>setCxFiltro(f=>({...f,forma:e.target.value}))} style={{...sInput,fontSize:12,minWidth:90}}><option value="">Todos</option>{FORMAS.map(fp=><option key={fp.k} value={fp.k}>{fp.l}</option>)}</select></div>
        <div><div style={{fontSize:10,color:DC.textMuted,marginBottom:2}}>Canal</div><select value={cxFiltro.canal} onChange={e=>setCxFiltro(f=>({...f,canal:e.target.value}))} style={{...sInput,fontSize:12,minWidth:90}}><option value="">Todos</option><option value="pdv_interno">PDV</option><option value="delivery">Delivery</option><option value="app">App</option></select></div>
        <button onClick={carregarRelatorio} disabled={cxLoading} style={{...sBtn(DC.green,"#fff"),padding:"8px 20px",opacity:cxLoading?.6:1}}>{cxLoading?"...":"🔍 Filtrar"}</button>
      </div>
    </div>
    {/* Tabela */}
    <div style={{flex:1,overflowY:"auto",padding:"0 20px 20px"}}>
      {cxRelatorio.length>0&&<div style={{display:"flex",gap:12,padding:"14px 16px",borderBottom:`2px solid ${DC.border}`,marginBottom:8,flexWrap:"wrap",alignItems:"center",background:DC.card,borderRadius:10,border:`1px solid ${DC.border}`}}>
        <div style={{fontSize:14,fontWeight:800,color:DC.green}}>{cxRelatorio.length} registros</div>
        <div style={{fontSize:14,fontWeight:900,color:DC.green,fontFamily:mono}}>Total: {fmt(relTot)}</div>
        {Object.entries(relPf).map(([f,v])=><div key={f} style={{fontSize:12,color:DC.textSoft,padding:"3px 10px",background:DC.bgSoft,borderRadius:6}}>{f}: <b style={{color:DC.text,fontFamily:mono}}>{fmt(v)}</b></div>)}
      </div>}
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr style={{borderBottom:`2px solid ${DC.border}`,position:"sticky",top:0,background:DC.bg,zIndex:1}}>{["Código","Data","Canal","Local","Caixa","Garçom","Pgto","Total",""].map(h=><th key={h} style={{padding:"10px 10px",textAlign:h===""?"center":"left",fontWeight:700,color:DC.textMuted,fontSize:11}}>{h}</th>)}</tr></thead>
        <tbody>{cxRelatorio.map((o,i)=><tr key={o.id||i} style={{borderBottom:`1px solid ${DC.border}20`}} onMouseOver={e=>{e.currentTarget.style.background=DC.card;}} onMouseOut={e=>{e.currentTarget.style.background="transparent";}}>
          <td style={{padding:"10px 10px",fontWeight:700,color:DC.blue,fontFamily:mono,fontSize:11}}>{o.codigo||"—"}</td>
          <td style={{padding:"10px 10px",color:DC.textSoft,whiteSpace:"nowrap"}}>{fmtDt(o.criado_em)}</td>
          <td style={{padding:"10px 10px"}}><span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:o.canal==="pdv_interno"?DC.greenSoft:o.canal==="delivery"?DC.orangeSoft:DC.blueSoft,color:o.canal==="pdv_interno"?DC.green:o.canal==="delivery"?DC.orange:DC.blue}}>{o.canal||"—"}</span></td>
          <td style={{padding:"10px 10px"}}>{o.endereco_entrega||"—"}</td>
          <td style={{padding:"10px 10px",color:DC.textSoft}}>{o.caixa_nome||"—"}</td>
          <td style={{padding:"10px 10px",color:DC.textSoft}}>{o.garcom_nome||"—"}</td>
          <td style={{padding:"10px 10px"}}><span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:DC.purpleSoft,color:DC.purple}}>{o.forma_pagamento||"—"}</span></td>
          <td style={{padding:"10px 10px",fontWeight:800,color:DC.green,fontFamily:mono,textAlign:"right"}}>{fmt(valorReal(o))}</td>
          <td style={{padding:"10px 6px",textAlign:"center"}}><div onClick={()=>reimprimirRecibo(o)} style={{cursor:"pointer",fontSize:14,padding:"4px 8px",borderRadius:6,border:`1px solid ${DC.border}`,background:DC.bgSoft,display:"inline-flex",alignItems:"center",justifyContent:"center",transition:"all .12s"}} onMouseOver={e=>{e.currentTarget.style.borderColor=DC.cyan;e.currentTarget.style.background=DC.card;}} onMouseOut={e=>{e.currentTarget.style.borderColor=DC.border;e.currentTarget.style.background=DC.bgSoft;}} title="Reimprimir recibo">🖨</div></td>
        </tr>)}</tbody>
      </table>
      {cxRelatorio.length===0&&!cxLoading&&<div style={{textAlign:"center",padding:60,color:DC.textMuted}}><div style={{fontSize:40,marginBottom:12}}>📊</div><div style={{fontSize:14,fontWeight:600}}>Use os filtros acima e clique Filtrar</div><div style={{fontSize:12,marginTop:4}}>O relatório será exibido aqui com opção de reimprimir cada recibo</div></div>}
      {cxLoading&&<div style={{textAlign:"center",padding:60,color:DC.textMuted}}><div style={{fontSize:14}}>Carregando...</div></div>}
    </div>
  </div>;
}

function KpiCard({ico,lb,vl,sub,cor}){
  return<div style={{background:DC.card,borderRadius:10,padding:14,border:`1px solid ${DC.border}`,display:"flex",gap:10,alignItems:"center"}}>
    <div style={{width:36,height:36,borderRadius:8,background:`${cor}15`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{ico}</div>
    <div><div style={{fontSize:9,color:DC.textMuted,fontWeight:600}}>{lb}</div><div style={{fontSize:16,fontWeight:900,fontFamily:mono}}>{vl}</div>{sub&&<div style={{fontSize:9,color:DC.textMuted}}>{sub}</div>}</div>
  </div>;
}
